<span>
  <div class="mb-1"
    [ngClass]="{'filterScrollFix': isPersonSearchListingPage, 'filterScrollFixTI': isReportDetails, 'companyCompareStick': isCompanyComparePage}">
    <div class="wccard mb-1 w-100 scrolltopback"
      [ngStyle]="{'padding': (extraInfo?.redirectSource != 'talent-insights' && extraInfo?.redirectSource != 'company-insights' && isSimilarCandidate == false) ? '10px' : '12px'}"
      *ngIf="isPersonSearchListingPage || isTalentInsightsPage || isCompanyComparePage">
      <div class="d-flex justify-content-between">
        <a data-testid="auto-person-search-filter-a-1" class="text-webbtree-green f-12" routerLinkActive="active" (click)="backButtonRedirection()"> <i
            class="fas fa-arrow-left"></i>
          Back
        </a>
        <div class="mb-0 f-12 ms-auto d-flex"
          *ngIf="(extraInfo?.redirectSource != 'talent-insights' && extraInfo?.redirectSource != 'company-insights' &&!isCompanyComparePage)">
          <span class="text-bluex pointer" *ngIf="!saveSearchTalentDiscoveryHistoryId"
            (click)="!isSearchSaved && !showLoaderbeforeDataLoad && saveSearch()">
            <i class="fa-regular fa-floppy-disk mr-0"></i>
            {{ isSearchSaved ? 'Saved' : isTalentInsightsPage ?  'Save Insights': 'Save Search' }}
          </span>
          <span *ngIf="saveSearchTalentDiscoveryHistoryId">
            <span class="dropdown ats-dropBtn ml-2">
              <button data-testid="auto-person-search-filter-button-1" class="dropdown-toggle save-btn  text-webbtree-green" type="button" id="userDropdownButton" (click)="toggleDropdown()"
                aria-haspopup="true" aria-expanded="false">
                <div class="d-flex align-items-center">
                  <span class="mr-2">{{isTalentInsightsPage ? 'Save Insights': 'Save Search'}}</span>
                  <i class="fas toggle-icon" [ngClass]="isOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </div>
              </button>

              <div class="dropdown-menu custom-dropdown" aria-labelledby="userDropdownButton"  [class.show]="isOpen">
                <a data-testid="auto-person-search-filter-a-2" class="dropdown-item d-flex align-items-center" (click)="saveSearch();closeDropdown();">

                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14 4.66667V12.6667C14 13.0333 13.8696 13.3473 13.6087 13.6087C13.3478 13.87 13.0338 14.0004 12.6667 14H3.33333C2.96667 14 2.65289 13.8696 2.392 13.6087C2.13111 13.3478 2.00044 13.0338 2 12.6667V3.33333C2 2.96667 2.13067 2.65289 2.392 2.392C2.65333 2.13111 2.96711 2.00044 3.33333 2H11.3333L14 4.66667ZM9.41667 11.4167C9.80556 11.0278 10 10.5556 10 10C10 9.44444 9.80556 8.97222 9.41667 8.58333C9.02778 8.19444 8.55556 8 8 8C7.44444 8 6.97222 8.19444 6.58333 8.58333C6.19444 8.97222 6 9.44444 6 10C6 10.5556 6.19444 11.0278 6.58333 11.4167C6.97222 11.8056 7.44444 12 8 12C8.55556 12 9.02778 11.8056 9.41667 11.4167ZM4 6.66667H10V4H4V6.66667Z"
                      fill="#2E93A1" />
                  </svg>
                  <span class="ml-1">Save as New</span>
                </a>

                <a data-testid="auto-person-search-filter-a-3" class="dropdown-item d-flex align-items-center" (click)="updateSaveSearch();closeDropdown();">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M4 6.66667H10V4H4V6.66667ZM3.33333 14C2.96667 14 2.65289 13.8696 2.392 13.6087C2.13111 13.3478 2.00044 13.0338 2 12.6667V3.33333C2 2.96667 2.13067 2.65289 2.392 2.392C2.65333 2.13111 2.96711 2.00044 3.33333 2H10.7833C10.9611 2 11.1307 2.03333 11.292 2.1C11.4533 2.16667 11.5949 2.26111 11.7167 2.38333L13.6167 4.28333C13.7389 4.40556 13.8333 4.54733 13.9 4.70867C13.9667 4.87 14 5.03933 14 5.21667V7.45C14 7.63889 13.9251 7.78889 13.7753 7.9C13.6256 8.01111 13.456 8.05 13.2667 8.01667C13.1667 8.00556 13.0667 8 12.9667 8C12.8667 8 12.7667 8.01111 12.6667 8.03333C12.4444 8.06667 12.2278 8.13622 12.0167 8.242C11.8056 8.34778 11.6111 8.48378 11.4333 8.65L10 10.0833V10C10 9.44444 9.80556 8.97222 9.41667 8.58333C9.02778 8.19444 8.55556 8 8 8C7.44444 8 6.97222 8.19444 6.58333 8.58333C6.19444 8.97222 6 9.44444 6 10C6 10.5556 6.19444 11.0278 6.58333 11.4167C6.97222 11.8056 7.44444 12 8 12H8.06667L7.73333 12.3333C7.61111 12.4556 7.514 12.6 7.442 12.7667C7.37 12.9333 7.33378 13.1056 7.33333 13.2833V13.3333C7.33333 13.5222 7.26956 13.6804 7.142 13.808C7.01444 13.9356 6.856 13.9996 6.66667 14H3.33333ZM8.66667 14.6667V13.5667C8.66667 13.4778 8.68333 13.3918 8.71667 13.3087C8.75 13.2256 8.8 13.1504 8.86667 13.0833L12.35 9.61667C12.45 9.51667 12.5611 9.44445 12.6833 9.4C12.8056 9.35556 12.9278 9.33333 13.05 9.33333C13.1833 9.33333 13.3111 9.35844 13.4333 9.40867C13.5556 9.45889 13.6667 9.53378 13.7667 9.63333L14.3833 10.25C14.4722 10.35 14.5418 10.4611 14.592 10.5833C14.6422 10.7056 14.6671 10.8278 14.6667 10.95C14.6662 11.0722 14.644 11.1973 14.6 11.3253C14.556 11.4533 14.4838 11.5671 14.3833 11.6667L10.9167 15.1333C10.85 15.2 10.7751 15.25 10.692 15.2833C10.6089 15.3167 10.5227 15.3333 10.4333 15.3333H9.33333C9.14444 15.3333 8.98622 15.2696 8.85867 15.142C8.73111 15.0144 8.66711 14.856 8.66667 14.6667ZM13.05 11.6L13.6667 10.95L13.05 10.3333L12.4167 10.9667L13.05 11.6Z"
                      fill="#2E93A1" />
                  </svg>
                  <span class="ml-1">{{isTalentInsightsPage ? 'Update Insights': 'Update Search'}}</span>
                </a>
              </div>
            </span>
          </span>

        </div>
      </div>

    </div>
    <div class="wccard p-3 mb-1 d-flex justify-content-between align-items-center onscrollStickTop">
      <p class="f-18 font-weight-500 text-black mb-0" *ngIf="!showAISourcingBackButton && isCalledFromComponent != 'resume-screen'">
        <img src="../../assets/filters.png" style="height: 18px; width: 18px;" />
        Filters
      </p>
      <span *ngIf="showAISourcingBackButton">
          <a data-testid="auto-person-search-filter-a-4" class="text-webbtree-green f-12" routerLinkActive="active" (click)="goBackToProjectList()">
              <i class="fas fa-arrow-left"></i> Back
          </a>
      </span>
      <span class="f-14 icon-color font-weight-500 text-webbtree-green pointer" *ngIf="isCalledFromComponent == 'resume-screen'" (click)="backButtonRedirection()">
        <i class="fa-solid fa-arrow-left"></i> Back
      </span>
      <span *ngIf="isCalledFromComponent != 'resume-screen' && !areAllFiltersCleared()" class="f-14 icon-color font-weight-500 text-webbtree-green pointer" (click)="resetAllFilters('all')">
        Reset All
      </span>
    </div>

    <div class="wccard p-2 mb-1 " *ngIf="shouldShowFilter(filterNames.KEYWORD_INPUT)">
      <!-- keyword or boolean search -->
      <div class="card bt">
        <div class="card-header" id="headingTwenty">
          <h5 class="mb-0 f-14">
            <div class="px-0 w-100">
              <div class="f-14  w-100">
                <div class="d-flex  w-100 align-items-center justify-content-between">
                  <span *ngIf="isCalledFromComponent != 'resume-screen'">Keyword or Boolean search</span>
                  <span *ngIf="isCalledFromComponent == 'resume-screen'">Search</span>

                  <span class="f-12 icon-color font-weight-500 text-webbtree-green pointer d-flex ms-auto"
                    (click)="clearFilters('search')" *ngIf="keywordInput?.value && !searchDisable">
                    Clear
                  </span>
                  <span class="f-12 icon-color font-weight-500 text-webbtree-green pointer d-flex ms-auto"
                    (click)="search($event);searchDisable=false; " *ngIf="keywordInput?.value && searchDisable">
                    Search
                  </span>
                </div>
              </div>
            </div>
          </h5>
        </div>

        <!-- <div id="collapseTwenty" class="collapse" aria-labelledby="headingTwenty"> -->
        <!-- [ngClass]="{'disabled-input': (!searchDisable), 'enable-input': searchDisable}" [readonly]="!searchDisable" (click)="searchDisable=true;" -->
        <div class="position-relative mt-1">
          <textarea data-testid="auto-person-search-filter-textarea-1" class="wc-form-control no-shadow w-100 inputheight searchScrollFix"
            *ngIf="isCalledFromComponent != 'resume-screen'" style="min-height: 66px; max-height: 300px;"
            [formControl]="keywordInput" [ngClass]="{'disabled-input': (!searchDisable), 'enable-input': searchDisable}"
            [readonly]="!searchDisable" (click)="searchDisable=true;"
            (keydown.enter)="search($event);searchDisable=false;" (input)="keyword($event)"
            placeholder="Enter Keyword or Boolean...."></textarea>

          <input data-testid="auto-person-search-filter-input-1" type="text" id="searchinput" *ngIf="isCalledFromComponent == 'resume-screen'"
            class="wc-form-control no-shadow w-100 searchScrollFix" [formControl]="keywordInput"
            [ngClass]="{'disabled-input': (!searchDisable), 'enable-input': searchDisable}" [readonly]="!searchDisable"
            (click)="searchDisable=true;" (keydown.enter)="search($event);searchDisable=false;"
            (input)="keyword($event)" placeholder="Search here">


          <div *ngIf="showSearchKeywordLoader" class=" spinner-border position-absolute text-black"
            style="top:13px; right: 7px;" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <!-- <mat-autocomplete #searchkeyword_auto="matAutocomplete" (optionSelected)="search(); searchDisable=false;">
                  <mat-option *ngFor="let keyword of searchKeywordList" [value]="keyword.value">
                    <span class="d-flex align-items-center">
                      <span class="text-truncate">{{keyword.value | titlecase}} </span>
                    </span>
                  </mat-option>
                </mat-autocomplete> -->

        </div>
        <!-- </div> -->
      </div>
    </div>

    <div class="bg-white">

      <!-- Overall Matched -->
      <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.OVERALL_MATCH)">
        <div class="card-header" id="headingOverAllMatched">
            <h5 class="mb-0 f-14">
                <div class="px-0 w-100">
                    <div class="f-14  w-100">
                        <div class="d-flex  w-100 align-items-baseline">
                            <button data-testid="auto-person-search-filter-button-2" (click)="toggleFilter('jobtitle')" id="collapseMatchFilter"
                                class="static btn  font-weight-500 flex-grow-1  text-left  f-14 ml--7 text-nowrap gen-ai-text"
                                type="button" data-bs-target="#collapseOverAllMatchFilter"

                                aria-controls="collapseOverAllMatchFilter">
                                Overall Match
                            </button>
                            <span class="toggle">
                                <div class="down" *ngIf="overallMatchFilters && overallMatchFilters.length > 0">
                                    <span class="red-dot" style="left: 120px; top:6px">&bull;</span>
                                </div>
                            </span>
                            <span class="toggle ml-auto mr-5" style="flex-shrink: 0;">
                                <div class="up">
                                    <span class="mb-2 d-flex align-items-baseline">
                                        <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex" *ngIf="overallMatchFilters?.length"
                                            (click)="clearFilters('overall')">
                                            Reset
                                        </span>
                                    </span>
                                </div>
                            </span>
                            <!-- <label for="collapseMatchFilter" class="toggle text-webbtree-green">
                                <span class="down mr-2"><i
                                        class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                                <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                            </label> -->
                </div>
              </div>
            </div>
          </h5>
        </div>
        <div id="collapseOverAllMatchFilter" class=" mb-2" aria-labelledby="headingOverAllMatched">
          <!-- <label class="wc-checkbox mr-2 mb-2 d-flex align-items-center">
                <input data-testid="auto-person-search-filter-input-2" type="checkbox" id="overAllMatch" name="ALL" (change)="addOverallMatchFilter($event, 'ALL')">
                <i class="fas fa-check"></i>
                <span class="ml-2">All</span>
            </label> -->

          <div class="mb-2 d-flex">
            <div class="excellent-match-check" style="width: 140px;">
              <label class="wc-checkbox mr-2 mb-0 d-flex align-items-center">
                <input data-testid="auto-person-search-filter-input-3" type="checkbox" id="ExcellentMatch" name="EXCELLENT"
                  (change)="addOverallMatchFilter($event, 'EXCELLENT')">
                <i class="fas fa-check"></i>
                <div class="ml-2">
                  <div style="width: 100px;">
                    Excellent Match
                  </div>
                </div>
              </label>

            </div>
            <div class="good-match-check ml-2" style="width: 118px;">
              <label class="wc-checkbox mr-2 mb-0 d-flex align-items-center">
                <input data-testid="auto-person-search-filter-input-4" type="checkbox" id="ExcellentMatch" name="GOOD" (change)="addOverallMatchFilter($event, 'GOOD')">
                <i class="fas fa-check"></i>
                <div class="ml-2">
                  <div style="width: 75px;">
                    Good Match
                  </div>
                </div>
              </label>

            </div>
          </div>
          <div class="d-flex">
            <div class="potential-match-check" style="width: 140px;">
              <label class="wc-checkbox mr-2 mb-0 d-flex align-items-center">
                <input data-testid="auto-person-search-filter-input-5" type="checkbox" id="ExcellentMatch" name="POTENTIAL"
                  (change)="addOverallMatchFilter($event, 'POTENTIAL')">
                <i class="fas fa-check"></i>
                <div class="ml-2">
                  <div style="width: 100px;">
                    Potential Match
                  </div>
                </div>
              </label>

            </div>
            <div class="not-match-check ml-2" style="width: 118px;" *ngIf="isCalledFromComponent == 'resume-screen'">
              <label class="wc-checkbox mr-2 mb-0 d-flex align-items-center">
                <input data-testid="auto-person-search-filter-input-6" type="checkbox" id="ExcellentMatch" name="NOT_A_MATCH"
                  (change)="addOverallMatchFilter($event, 'NOT_A_MATCH')">
                <i class="fas fa-check"></i>
                <div class="ml-2">
                  <div style="width: 75px;">
                    Not a Match
                  </div>
                </div>
              </label>

            </div>
          </div>
        </div>
      </div>

      <!-- Job Title-->
      <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.JOB_TITLE)">
        <div class="card-header" id="headingOne">
          <h5 class="mb-0 f-14">
            <div class="px-0 w-100">
              <div class="f-14  w-100">
                <div class="d-flex  w-100 align-items-baseline">
                  <button data-testid="auto-person-search-filter-button-3" (click)="toggleFilter('jobtitle')" id="collapseOneBtn"
                    class="static btn  font-weight-500 flex-grow-1  text-left  f-14 ml--7 text-nowrap"
                    [ngClass]="{'collapsed': jobTitleSelectedList?.length == 0 && !showOpenAITitleSuggestions}"
                    type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                    [attr.aria-bs-expanded]="jobTitleSelectedList?.length ? 'true': 'false'" aria-bs-controls="collapseOne">
                    Job Title
                  </button>
                  <span class="toggle" *ngIf="jobTitleSelectedList?.length">
                    <div class="down">
                      <span class="red-dot">&bull;</span>
                    </div>
                  </span>
                  <span class="toggle" style="flex-shrink: 0;">
                    <div class="up">
                      <span class="mb-1 d-flex align-items-baseline">

                        <div class="col mr-2" *ngIf="shouldShowStatus()">
                          <select data-testid="auto-person-search-filter-select-1" name="jobTitleStatus" (change)="filterByStatus($event, 'jobtitle')"
                            class="new-form no-shadow wc-select f-12" [(ngModel)]="jobTitleStatus">
                            <option value="Current" selected>Current</option>
                            <option value="Current or Past">Current or Past</option>
                          </select>
                        </div>
                        <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex mr-2"
                          (click)="clearFilters('jobtitle')" *ngIf="jobTitleSelectedList?.length">
                          Reset
                        </span>
                      </span>
                    </div>
                  </span>
                  <label for="collapseOneBtn" class="toggle text-webbtree-green">
                    <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                    <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                  </label>
                </div>
              </div>
            </div>
          </h5>
        </div>
        <div id="collapseOne" class="collapse mb-2"
          [class.show]="isExpanded('jobtitle', jobTitleSelectedList)"
          aria-bs-labelledby="headingOne">

    <mat-chip-grid #jobtitle_chipList>
  <mat-chip-row
    class="mr-2 mb-1 rightsideclose text-truncate d-flex"
    *ngFor="let jobtitle of jobTitleSelectedList"
    [ngClass]="{
      'bg-ai-chip': jobtitle.isSuggested,
      'bg-chip': !jobtitle.isSuggested,
      'excluded-chip': jobtitle.isExcluded
    }"
    (removed)="removeChip(jobtitle, 'jobtitle')">

    <!-- ✅ Text FIRST -->
    <span class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center font-weight-lighter">
      <span
        class="mx-1 chip-text text-truncate"
        [matTooltip]="jobtitle.chipkey | titlecase"
        [matTooltipClass]="{ 'hire-filter text-black': true }"
        matTooltipPosition="above">
        {{ jobtitle.chipkey | titlecase }}
      </span>
      <mat-icon
        *ngIf="jobtitle.isExcluded"
        class="f-12 mr--5 mt-1 text-danger"
        matTooltip="Excluded"
        [matTooltipClass]="{ 'red-tooltip text-black': true }">
        <i class="fas fa-minus-circle pointer" (click)="excludeFilterItem(jobtitle.key,'jobtitle')"></i>
      </mat-icon>
      <mat-icon
        *ngIf="!jobtitle.isExcluded"
        matTooltip="Exclude"
        [matTooltipClass]="{ 'red-tooltip text-black': true }"
        class="f-12 mr--5 mt-1">
        <i class="far fa-minus-circle pointer" (click)="excludeFilterItem(jobtitle.key,'jobtitle')"></i>
      </mat-icon>
    </span>

    <!-- ✅ Remove button LAST with matChipRemove on button, not span -->
    <button data-testid="auto-person-search-filter-button-4" matChipRemove class="chip-remove-btn">
      <i class="far fa-times f-12 font-weight-lighter"></i>
    </button>

  </mat-chip-row>
</mat-chip-grid>
          <div class="position-relative">
            <input data-testid="auto-person-search-filter-input-7" class="wc-form-control no-shadow w-100 inputheight mb-2" [formControl]="jobTitleInput"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes" #trigger="matAutocompleteTrigger"
              (click)="typeAheadSearch($event, 'jobtitle')"
              (keyup.enter)="addToSelectedList($event.target.value,'jobtitle', 'enter');$event.target.blur();trigger.closePanel()"
              (keyup)="onTypeAheadSearch($event, 'jobtitle')" placeholder="Enter Job Title or Boolean...."
              [matAutocomplete]="jobtitle_auto" [matChipInputFor]="jobtitle_chipList"
              [matChipInputAddOnBlur]="addOnBlur" (blur)="removeTypeahead('jobtitle')">
            <div *ngIf="showJobTitleLoader" class=" spinner-border position-absolute text-black"
              style="top:13px; right: 7px;" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <mat-autocomplete #jobtitle_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'jobtitle')">
              <mat-option *ngFor="let jt of jobTitleList" [value]="{key: jt.value, doc_count: jt.doc_count}"
                [matTooltip]="jt.value | titlecase" [matTooltipClass]="{ 'hire-filter text-black': true }"
                matTooltipPosition="above">
                <span class="d-flex align-items-center">
                  <span class="text-truncate">{{jt.value | titlecase}} </span>
                  <!-- <span class="f-12 text-9696">({{jt.doc_count}})</span> -->
                </span>
              </mat-option>
            </mat-autocomplete>
            <div class="d-flex flex-column" *ngIf="!shouldShowSuggestions() || isCalledFromComponent == 'ai-sourcing'">
              <div *ngIf="!aiQuery || isCalledFromComponent == 'ai-sourcing'">
                <span class="trim-chip underline-on-hover mb-2 ml-1 d-flex align-items-center"
                  *ngFor="let jt of jobTitleTopList" (click)="addToSelectedList(jt,'jobtitle')"
                  [matTooltip]="jt.key | titlecase" [matTooltipClass]="{ 'hire-filter text-black': true }"
                  matTooltipPosition="above">
                  <span class="text-truncate ">{{jt.key | titlecase}}</span>
                  <span class="f-12 text-9696">({{jt.doc_count | number:'1.0':'en-US'}})</span>
                </span>
              </div>
              <!-- ai suggestion -->
              <div style="overflow: hidden;"
                [ngStyle]="{ 'height': showOpenAITitleSuggestions && !isOpenAITitleLoading ? 'auto': '0px' }"
                *ngIf="isCalledFromComponent != 'ai-sourcing'">
                <div class="pr-2 flex-shrink-0 d-flex align-items-center mb-2"
                  *ngIf="showOpenAITitleSuggestions && !isOpenAITitleLoading">
                  <span style="line-height: 1.9;" class="ai-text-gradient font-weight-500 ml-1">
                    <i class="fa fa-stars"></i>
                    AI Search Suggestions
                  </span>
                  <i class="fal fa-info-circle ml-1 pointer"
                    matTooltip="Get AI recommended job titles and skills to expand your search and get enhanced results."
                    [matTooltipClass]="{ 'hire-filter text-black': true }" matTooltipPosition="above"></i>
                </div>
                <div *ngIf="isOpenAITitleLoading" class="shimmer-loader ml-1"
                  style="height: 23px; width: 300px; border-radius: 10px;"></div>
                <openai-suggested-titles [onlyExisiting]="true" [continent]="selectedContinent ? [selectedContinent]:[]"
                  showOnly="titles" [showIcons]="false" [showCount]="false" (change)="setTitleSuggestions($event)"
                  (loading)="openaiTitleLoading($event)" [query]="aiQuery" [updateChips]="updatedAiTitleChips"
                  [selectedTitles]="selectedTitles" [exclude]="openAIExcludeJobTitles" [removeSelected]="true"
                  [maxChips]="5" [column]="true" [titleAggregateType]="jobTitleAggregateType" [titleType]="jobTitleType"
                  [jobtitleAndSkillAIData]="jobtitleAndSkillAIData"></openai-suggested-titles>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Past Job Titles -->
      <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.PAST_JOB_TITLE)">
        <div class="card-header" id="headingPastJobTitles">
          <h5 class="mb-0 f-14">
            <div class="px-0 w-100">
              <div class="f-14 w-100">
                <div class="d-flex w-100 align-items-baseline">
                  <button data-testid="auto-person-search-filter-button-5" (click)="!shouldShowSuggestions() && toggleFilter(filterNames.PAST_JOB_TITLE)"
                    id="collapsePastJobTitleBtn" [ngClass]="{'collapsed': pastJobTitleSelectedList?.length == 0}"
                    class="static font-weight-500 text-left flex-grow-1 btn f-14 ml--7" type="button"
                    data-bs-toggle="collapse" data-bs-target="#collapsePastJobTitle" aria-bs-expanded="false"
                    aria-bs-controls="collapsePastJobTitle"> Past Job Title
                  </button>
                  <span class="toggle mr-5" style="flex-shrink: 0;">
                    <div class="down">
                      <span *ngIf="pastJobTitleSelectedList.length" class="red-dot pjt-red-dot">&bull;</span>
                    </div>
                  </span>
                  <span class="toggle ml-auto mr-5" style="flex-shrink: 0;">
                    <div class="up">
                      <span class="mb-2 d-flex align-items-baseline">
                        <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex"
                          (click)="clearFilters(filterNames.PAST_JOB_TITLE)" *ngIf="pastJobTitleSelectedList.length">
                          Reset
                        </span>
                      </span>
                    </div>
                  </span>
                  <label for="collapsePastJobTitleBtn" class="toggle text-webbtree-green">
                    <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                    <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                  </label>
                </div>
              </div>
            </div>
          </h5>
        </div>

        <div id="collapsePastJobTitle" class="collapse mb-2"
         [class.show]="isExpanded(filterNames.PAST_JOB_TITLE, pastJobTitleSelectedList)"
          aria-bs-labelledby="collapsePastJobTitle">
          <mat-chip-grid #past_jobtitle_chipList>
            <mat-chip-row class="mr-2 mb-1 rightsideclose text-truncate d-flex"
               [removable]="removable" (removed)="removeChip(cl, filterNames.PAST_JOB_TITLE)"
              *ngFor="let cl of pastJobTitleSelectedList"
              [ngClass]="{ 'bg-ai-chip': cl.isSuggested, 'bg-chip': !cl.isSuggested, 'excluded-chip': cl.isExcluded }">
               <span matChipRemove  class="mr-1">
              <i class="far fa-times f-12 font-weight-lighter"></i>
                </span>
              <span
                class="trim-chip text-truncate f-12 font-weight-lighter hoverable-element d-flex align-items-center">
                <span class="mx-1 chip-text text-truncate" [matTooltip]="cl.chipkey | titlecase"
                  [matTooltipClass]="{ 'hire-filter text-black': true }" matTooltipPosition="above">{{cl.chipkey |
                  titlecase}}</span>
                <mat-icon *ngIf="cl.isExcluded" class="f-14 mr--5 text-danger" matTooltip="Excluded"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fas fa-minus-circle pointer"
                    (click)="excludeFilterItem(cl.key, filterNames.PAST_JOB_TITLE)"></i></mat-icon>
                <mat-icon *ngIf="!cl.isExcluded" class="f-14 mr--5" matTooltip="Exclude"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="far fa-minus-circle pointer"
                    (click)="excludeFilterItem(cl.key, filterNames.PAST_JOB_TITLE)"></i></mat-icon>
              </span>
            </mat-chip-row>
          </mat-chip-grid>
          <div class="position-relative">
            <input data-testid="auto-person-search-filter-input-8" class="wc-form-control no-shadow w-100 inputheight mb-2" placeholder="Enter Past Job Title...."
              [formControl]="pastJobTitleInput" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (click)="typeAheadSearch($event, filterNames.PAST_JOB_TITLE)"
              (keyup)="onTypeAheadSearch($event, filterNames.PAST_JOB_TITLE)"
              (keyup.enter)="addToSelectedList($event.target.value, filterNames.PAST_JOB_TITLE, 'enter');$event.target.blur();trigger.closePanel()"
              [matAutocomplete]="past_job_title_auto" [matChipInputFor]="past_jobtitle_chipList"
              [matChipInputAddOnBlur]="addOnBlur" (blur)="removeTypeahead('pastjobtitle')">
            <div *ngIf="showPastJobTitleLoader" class=" spinner-border position-absolute text-black"
              style="top:13px; right: 7px;" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <mat-autocomplete #past_job_title_auto="matAutocomplete"
              (optionSelected)="selectedItem($event, filterNames.PAST_JOB_TITLE)">
              <mat-option *ngFor="let cl of pastJobTitleList" [value]="{key: cl.value, doc_count: cl.doc_count}"
                [matTooltip]="cl.value | titlecase" [matTooltipClass]="{ 'hire-filter text-black': true }"
                matTooltipPosition="above">
                {{cl.value | titlecase}}
              </mat-option>
            </mat-autocomplete>
            <div class="d-flex flex-column">
              <div *ngIf="!aiQuery">
                <span class="trim-chip  underline-on-hover mb-2 ml-1 d-flex" *ngFor="let jt of pastJobTitleTopList"
                  (click)="addToSelectedList(jt,filterNames.PAST_JOB_TITLE)" [matTooltip]="jt.key | titlecase"
                  [matTooltipClass]="{ 'hire-filter text-black': true }" matTooltipPosition="above">
                  <span class="text-truncate">{{jt.key | titlecase}}</span>
                  <span class="f-12 text-9696 ml-1">({{jt.doc_count | number:'1.0':'en-US'}})</span>
                </span>
              </div>

              <!-- ai suggestion -->
              <div style="overflow: hidden;"
                [ngStyle]="{ 'height': showOpenAIPastJobTitleSuggestions && !isOpenAIPastJobTitleLoading ? 'auto': '0px' }">
                <div class="pr-2 flex-shrink-0 d-flex align-items-center mb-2"
                  *ngIf="showOpenAIPastJobTitleSuggestions && !isOpenAIPastJobTitleLoading">
                  <span style="line-height: 1.9;" class="ai-text-gradient font-weight-500 ml-1">
                    <i class="fa fa-stars"></i>
                    AI Search Suggestions
                  </span>
                  <i class="fal fa-info-circle ml-1 pointer"
                    matTooltip="Get AI recommended job titles and skills to expand your search and get enhanced results."
                    [matTooltipClass]="{ 'hire-filter text-black': true }" matTooltipPosition="above"></i>
                </div>
                <div *ngIf="isOpenAIPastJobTitleLoading" class="shimmer-loader ml-1"
                  style="height: 23px; width: 300px; border-radius: 10px;"></div>
                <openai-suggested-titles [removeSelected]="true" [onlyExisiting]="true" showOnly="pasttitle"
                  [showIcons]="false" [continent]="selectedContinent ? [selectedContinent]:[]" [showCount]="false"
                  (change)="setPastJobTitleSuggestions($event)" (loading)="openaiPastJobTitleLoading($event)"
                  [exclude]="openAIExcludePastJobTitles" [query]="aiQuery" [maxChips]="5" [column]="true"
                  [updateChips]="updatedAiPastJobTitleChips" [titleAggregateType]="pastJobTitleAggregateType"
                  [titleType]="pastJobTitleType" [jobtitleAndSkillAIData]="jobtitleAndSkillAIData">
                </openai-suggested-titles>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Location-->
      <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.LOCATION)">
        <div class="card-header" id="headingTwo">
            <h5 class="mb-0 f-14">
                <div class="px-0 w-100">
                    <div class="f-14 w-100" >
                        <div class="d-flex w-100 align-items-baseline">
                            <button data-testid="auto-person-search-filter-button-6" (click)="!shouldShowSuggestions() && toggleFilter('location')" id="collapseTwoBtn"  [ngClass]="{'collapsed': locationSelectedList?.length == 0}" class="static font-weight-500 text-left flex-grow-1 btn f-14 ml--7" type="button" data-bs-toggle="collapse" aria-bs-expanded="false" aria-bs-controls="collapseTwo" data-bs-target="#collapseTwo"> Location
                              <i class="fa-regular fa-circle-info f-12" *ngIf="(defaultContinent && (locationSelectedList?.length == 0 && locationcontinentsName?.length == 0) && (!comingFromJd && !comingFromNL && !isSimilarCanidate && !isRedirectedFromCompanyInsights && !isRedirectedFromTalentInsights && !isCompanyComparePage && !isCompanyInsightsDetails && !isAiSourcingTab))" [ngbTooltip]="tooltipTemplate" container="body"></i>
                            </button>
                              <ng-template #tooltipTemplate>
                                Showing results for <b>{{ defaultContinent | titlecase }}</b>, add locations to search globally.
                              </ng-template>
                            <span class="toggle mr-5" style="flex-shrink: 0;">
                                <div class="down">
                                    <span *ngIf="locationSelectedList?.length"  class="red-dot">&bull;</span>
                                </div>
                            </span>
                            <span class="toggle ml-auto mr-5" style="flex-shrink: 0;">
                                <div class="up">
                                    <span class="mb-2 d-flex align-items-baseline">
                                            <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex" (click)="clearFilters('location')" *ngIf="locationSelectedList?.length">
                                           Reset
                                        </span>
                                    </span>
                                </div>
                            </span>
                            <label for="collapseTwoBtn" class="toggle text-webbtree-green">
                                <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                                <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                            </label>
                        </div>
                    </div>
                </div>

          </h5>
        </div>

        <div id="collapseTwo" class="collapse mb-2"  [class.show]="isExpanded('location', locationSelectedList)"
          aria-bs-labelledby="collapseTwo">
          <mat-chip-grid #location_chipList>
            <mat-chip-row class="mr-2 mb-1 rightsideclose text-truncate d-flex"
               [removable]="removable" (removed)="removeChip(cl, 'location')"
              style="background-color: #e4f1f3;" [ngClass]="{'excluded-chip': cl.isExcluded}"
              *ngFor="let cl of locationSelectedList">
              <span matChipRemove class="mr-1">
              <i class="far fa-times f-12 font-weight-lighter"></i>
                </span>
              <span
                class="trim-chip text-truncate f-12 font-weight-lighter hoverable-element d-flex align-items-center">
                <span class="mr-1 chip-text text-truncate" [matTooltip]="cl.chipkey | titlecase"
                  [matTooltipClass]="{ 'hire-filter text-black': true }" matTooltipPosition="above">{{cl.chipkey |
                  titlecase}}</span>
                <mat-icon *ngIf="cl.isExcluded" class="f-14 mr--5 text-danger" matTooltip="Excluded"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fas fa-minus-circle pointer"
                    (click)="excludeFilterItem(cl.key,'location')"></i></mat-icon>
                <mat-icon *ngIf="!cl.isExcluded" class="f-14 mr--5" matTooltip="Exclude"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="far fa-minus-circle pointer"
                    (click)="excludeFilterItem(cl.key,'location')"></i></mat-icon>
              </span>
            </mat-chip-row>
          </mat-chip-grid>
          <div class="position-relative">
            <input data-testid="auto-person-search-filter-input-9" class="wc-form-control no-shadow w-100 inputheight mb-2" placeholder="Enter Location...."
              #trigger="matAutocompleteTrigger" [formControl]="locationInput"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodesForLocation"
              (click)="typeAheadSearch($event, 'location')" (keyup)="onTypeAheadSearch($event, 'location')"
              [matAutocomplete]="location_auto" [matChipInputFor]="location_chipList"
              [matChipInputAddOnBlur]="addOnBlur" (blur)="removeTypeahead('location')">
            <div *ngIf="showLocationLoader" class=" spinner-border position-absolute text-black"
              style="top:13px; right: 7px;" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <mat-autocomplete #location_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'location')">
              <mat-option *ngFor="let cl of locationList"
                [value]="{key: cl.value, doc_count: cl.doc_count, continent: cl?.location_continent, type: cl?.location_type}"
                [matTooltip]="getTooltipText(cl)" [matTooltipClass]="{ 'eu-tooltip text-black': true }"
                matTooltipPosition="above" [disabled]="isLocationDisabled(cl)">
                <span style="display: flex!important; align-items: center;">
                  <span class="text-truncate" style="width: 240px;">{{cl.value | titlecase}}</span>
                  <span class="f-12 text-9696 float-right ml-auto">{{cl?.location_type | titlecase}}</span>
                </span>
              </mat-option>
            </mat-autocomplete>
            <div class="d-flex flex-column" *ngIf="!shouldShowSuggestions()">
              <span class="trim-chip  underline-on-hover mb-2 ml-1 d-flex" *ngFor="let jt of locationTopList"
                (click)="addToSelectedList(jt,'location')" [matTooltip]="jt.key | titlecase"
                [matTooltipClass]="{ 'hire-filter text-black': true }" matTooltipPosition="above">
                <span class="text-truncate">{{jt.key | titlecase}}</span>
                <span class="f-12 text-9696 ml-1">({{jt.doc_count | number:'1.0':'en-US'}})</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="card bt px-2"
        *ngIf="!isSimilarCanidate && !comingFromJd && isCalledFromComponent !== 'ai-sourcing' && isCalledFromComponent !== 'resume-screen' && !comingFromNL">
        <div class="card-header" id="headingDistance">
          <h5 class="mb-0 f-14">
            <div class="px-0 w-100">
              <div class="f-14 w-100">
                <div class="d-flex w-100 align-items-baseline">
                  <button data-testid="auto-person-search-filter-button-7" id="collapseDistanceBtn" [ngClass]="{'collapsed': locationSelectedList?.length == 0}"
                    class="static font-weight-500 text-left flex-grow-1 btn f-14 ml--7 collapsed" type="button"
                    data-bs-toggle="collapse" data-bs-target="#collapseDistance" aria-bs-expanded="false"
                    aria-bs-controls="collapseDistance">
                    Distance <i class="fa-regular fa-circle-info f-12"
                      matTooltip="Distance filter is effective only for city-level locations"
                      [matTooltipClass]="{ 'red-tooltip text-black': true }"></i>
                  </button>
                  <span class="toggle mr-5" style="flex-shrink: 0;">
                    <div class="down">
                      <span *ngIf="locationSelectedList?.length" class="red-dot" style="left: 105px;">&bull;</span>
                    </div>
                  </span>
                  <label for="collapseDistanceBtn" class="toggle text-webbtree-green">
                    <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                    <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                  </label>
                </div>
              </div>
            </div>
          </h5>
        </div>

        <div id="collapseDistance" class="collapse mb-2" aria-bs-labelledby="headingDistance"
          [ngClass]="{'show': locationSelectedList?.length > 0}">
          <div class="d-flex align-items-center ml-2 w-100">
            <!-- <label class="f-14 text-black mr-2">From</label> -->
            <input data-testid="auto-person-search-filter-input-10" class="wc-form-control no-shadow inputheight mb-2 mr-2 w-100" type="number" onwheel="this.blur()"
              min="0" required [(ngModel)]="locationDistanceRange" (keyup)="wholeNumberValidation($event)"
              placeholder="" [disabled]="location_type !== 'city'">
            <span class="toggle ml-auto mr-5" style="flex-shrink: 0;">
              <div class="up">
                <select data-testid="auto-person-search-filter-select-2" name="" [(ngModel)]="locationDistanceUnit" class="locationUnit no-shadow wc-select f-12"
                  [disabled]="location_type !== 'city'">
                  <option value="kilometers" selected>Kms</option>
                  <option value="miles">Miles</option>
                </select>
              </div>
            </span>
          </div>
          <p *ngIf="!wholeNumberForDistance" class="text-danger f-12 ml-2" style="margin-bottom: 5px;">
            Only whole numbers are allowed</p>
          <p *ngIf="locationDistanceRange < 0" class="text-danger f-12 ml-2" style="margin-bottom: 5px;">
            Value should be greater than 0</p>
          <p *ngIf="locationDistanceRange > 500" class="text-danger f-12 ml-2" style="margin-bottom: 5px;">
            Value should be less than 500</p>


          <div class="col position-relative wccard mt-1">
            <div class="d-flex justify-content-end align-items-center">
              <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex mr-4"
                (click)="clearFilters('locationRange')">
                Reset
              </span>
              <button data-testid="auto-person-search-filter-button-8" class="btn btn-sm m-0" (click)="selectedItem(null,'locationRange')"
                [disabled]="!locationSelectedList?.length || !wholeNumberForDistance || locationDistanceRange < 0 || locationDistanceRange > 500"
                [ngClass]="(!locationSelectedList?.length || !wholeNumberForDistance || locationDistanceRange < 0 || locationDistanceRange > 500) ? 'disabled-button' : 'enabled-button'">Apply</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Skills -->
      <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.SKILLS)">
        <div class="card-header" id="headingThree">
          <h5 class="mb-0 f-14">
            <div class="px-0 w-100">
              <div class="f-14 w-100">
                <div class="d-flex w-100 align-items-baseline">
                  <button data-testid="auto-person-search-filter-button-9" (click)="!shouldShowSuggestions() && toggleFilter('skills')"
                    id="collapseThreeBtn" class="static flex-grow-1 font-weight-500 text-left  btn f-14 ml--7"
                    [ngClass]="{'collapsed': skillsSelectedList?.length == 0 && !showOpenAISkillsSuggestions }"
                    type="button" aria-bs-expanded="false" data-bs-toggle="collapse" data-bs-target="#collapseThree"
                    aria-bs-controls="collapseThree"> Skills
                  </button>
                  <span class="toggle mr-5" style="flex-shrink: 0;">
                    <div class="down">
                      <span *ngIf="skillsSelectedList?.length" class="red-dot" style="left: 60px;">&bull;</span>
                    </div>
                  </span>
                  <span class="toggle ml-auto mr-5" style="flex-shrink: 0;">
                    <div class="up">
                      <span class="mb-2 d-flex align-items-baseline">
                        <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex"
                          (click)="clearFilters('skills')" *ngIf="skillsSelectedList?.length">
                          Reset
                        </span>
                      </span>
                    </div>
                  </span>
                  <label for="collapseThreeBtn" class="toggle text-webbtree-green">
                    <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                    <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                  </label>
                </div>
              </div>
            </div>
          </h5>
        </div>

        <div id="collapseThree" class="collapse mb-2"
          [class.show]="isExpanded('skills', skillsSelectedList)"
          aria-bs-labelledby="headingThree">
          <mat-chip-grid #skills_chipList>
            <mat-chip-row class="mr-2 mb-1 rightsideclose text-truncate d-flex"
               [removable]="removable" (removed)="removeChip(s, 'skills')"
              [ngClass]="{ 'bg-ai-chip': s.isSuggested, 'bg-chip': !s.isSuggested, 'excluded-chip': s.isExcluded }"
              *ngFor="let s of skillsSelectedList">
               <span matChipRemove  class="mr-1">
              <i class="far fa-times f-12 font-weight-lighter"></i>
                </span>
              <span
                class="trim-chip text-truncate f-12 font-weight-lighter hoverable-element d-flex align-items-center">
                <mat-icon *ngIf="s.isMandatory" matTooltip="Marked as mandatory"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }" class="f-14 mr--10 mt-1 text-webbtree-green"><i
                    class="fas fa-thumbtack pointer" (click)="mandatoryFilterItem(s.key,'skills')"></i></mat-icon>
                <mat-icon *ngIf="!s.isMandatory" matTooltip="Mark as mandatory"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }" class="f-14 mr--10 mt-1"><i
                    class="fal fa-thumbtack pointer" (click)="mandatoryFilterItem(s.key,'skills')"></i></mat-icon>

                <span class="mx-1 tooltip-overflow-text text-truncate" [matTooltip]="s.chipkey | titlecase"
                  [matTooltipClass]="{ 'hire-filter text-black': true }" matTooltipPosition="above">{{s.chipkey |
                  titlecase}}</span>

                    <mat-icon *ngIf="s.isExcluded" class="f-14 mr--5 text-danger" matTooltip="Excluded"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fas fa-minus-circle pointer"
                    (click)="excludeFilterItem(s.key,'skills')"></i></mat-icon>
                <mat-icon *ngIf="!s.isExcluded" class="f-14 mr--5" matTooltip="Exclude"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="far fa-minus-circle pointer"
                    (click)="excludeFilterItem(s.key,'skills')"></i></mat-icon>
              </span>
            </mat-chip-row>
          </mat-chip-grid>
          <div class="position-relative">
            <input data-testid="auto-person-search-filter-input-11" class="wc-form-control no-shadow w-100 inputheight mb-2" placeholder="Enter Skills or Boolean...."
              [formControl]="skillsInput" #trigger="matAutocompleteTrigger"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (click)="typeAheadSearch($event, 'skills')"
              (keyup)="onTypeAheadSearch($event, 'skills')" [matAutocomplete]="skills_auto"
              (keyup.enter)="addToSelectedList($event.target.value,'skills', 'enter');$event.target.blur();trigger.closePanel()"
              [matChipInputFor]="skills_chipList" [matChipInputAddOnBlur]="addOnBlur"
              (blur)="removeTypeahead('skills')">
            <div *ngIf="showSkillLoader" class=" spinner-border position-absolute text-black"
              style="top:13px; right: 7px;" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <mat-autocomplete #skills_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'skills')">
              <mat-option *ngFor="let s of skillsList" [value]="{key: s.value, doc_count: s.doc_count}"
                [matTooltip]="s.value | titlecase" [matTooltipClass]="{ 'hire-filter text-black': true }"
                matTooltipPosition="above">
                <span class="d-flex align-items-center">
                  <span class="text-truncate">{{s.value | titlecase}}</span>
                  <!-- <span class="f-12 text-9696"> {{s.doc_count}}</span> -->
                </span>
              </mat-option>
            </mat-autocomplete>
            <div class="d-flex flex-column" *ngIf="!shouldShowSuggestions() || isCalledFromComponent == 'ai-sourcing'">
              <div *ngIf="!aiQuery || isCalledFromComponent == 'ai-sourcing'">
                <span class="trim-chip underline-on-hover mb-2 ml-1 d-flex" *ngFor="let skill of skillsTopList"
                  (click)="addToSelectedList(skill,'skills')" [matTooltip]="skill.key | titlecase"
                  [matTooltipClass]="{ 'hire-filter text-black': true }" matTooltipPosition="above">
                  <span class="text-truncate">{{skill.key | titlecase}}</span>
                  <span class="f-12 text-9696 ml-1">({{skill.doc_count | number:'1.0':'en-US'}})</span>
                </span>
              </div>

              <!-- ai suggestions -->
              <div style="overflow: hidden;"
                [ngStyle]="{ 'height': showOpenAISkillsSuggestions && !isOpenAISkillsLoading ? 'auto': '0px' }"
                *ngIf="isCalledFromComponent != 'ai-sourcing'">
                <div class="pr-2 flex-shrink-0 d-flex align-items-center mb-2"
                  *ngIf="showOpenAISkillsSuggestions && !isOpenAISkillsLoading">
                  <span style="line-height: 1.9;" class="ai-text-gradient font-weight-500 ml-1">
                    <i class="fa fa-stars"></i>
                    AI Search Suggestions
                  </span>
                  <i class="fal fa-info-circle ml-1 pointer"
                    matTooltip="Get AI recommended job titles and skills to expand your search and get enhanced results."
                    [matTooltipClass]="{ 'hire-filter text-black': true }" matTooltipPosition="above"></i>
                </div>
                <div *ngIf="isOpenAISkillsLoading" class="shimmer-loader ml-1"
                  style="height: 23px; width: 300px; border-radius: 10px;"></div>
                <div class="overflow-hidden">
                  <openai-suggested-titles [onlyExisiting]="true" showOnly="skills"
                    [continent]="selectedContinent ? [selectedContinent]:[]" [showIcons]="false" [showCount]="false"
                    (change)="setSkillsSuggestions($event)" (loading)="openaiSkillsLoading($event)" [query]="aiQuery"
                    [updateChips]="updatedAiSkillChips" [selectedTitles]="selectedSkills"
                    [exclude]="openAIExcludeSkills" [removeSelected]="true" [maxChips]="5" [column]="true"
                    [jobtitleAndSkillAIData]="jobtitleAndSkillAIData"></openai-suggested-titles>
                </div>
              </div>

            </div>
          </div>


        </div>
      </div>

      <!-- Company -->
      <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.COMPANY)">
        <div class="card-header" id="headingFour">
          <h5 class="mb-0 f-14">
            <div class="px-0 w-100">
              <div class="f-14 w-100">
                <div class="d-flex w-100 align-items-baseline">
                  <button data-testid="auto-person-search-filter-button-10" id="collapseFourBtn"
                    (click)="!shouldShowSuggestions() && toggleFilter('company')"
                    class="static font-weight-500 text-left flex-grow-1 btn f-14 ml--7"
                    [ngClass]="{'collapsed': companySelectedList?.length == 0}" type="button"  aria-bs-expanded="false" aria-bs-controls="collapseFour" data-bs-target="#collapseFour" data-bs-toggle="collapse"> Company
                  </button>
                  <span class="toggle mr-5" style="flex-shrink: 0;">
                    <div class="down">
                      <span *ngIf="companySelectedList?.length" class="red-dot" style="left: 100px;">&bull;</span>
                    </div>
                  </span>

                  <span class="toggle ml-auto mr-5" style="flex-shrink: 0;">
                    <div class="up">
                      <div class="d-flex align-items-center mb-2">
                        <div class="mr-2" *ngIf="shouldShowStatus()">
                          <select data-testid="auto-person-search-filter-select-3" name="companyStatus" (change)="filterByStatus($event, 'company')"
                            [(ngModel)]="companyStatus" class="new-form no-shadow wc-select f-12"
                            [disabled]="!shouldShowStatusCompany">
                            <option value="Current" selected>Current</option>
                            <option value="Current or Past">Current or Past</option>
                            <option value="Past">Past</option>
                          </select>
                        </div>
                        <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex"
                          (click)="clearFilters('company')" *ngIf="companySelectedList?.length">
                          Reset
                        </span>
                      </div>
                    </div>
                  </span>
                  <label for="collapseFourBtn" class="toggle text-webbtree-green">
                    <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                    <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                  </label>
                </div>
              </div>
            </div>
          </h5>
        </div>

        <div id="collapseFour" class="collapse mb-2" [class.show]="isExpanded('company', companySelectedList)"
          aria-bs-labelledby="headingFour">

          <mat-chip-grid #company_chipList class="company-mat-chip">
            <mat-chip-row class="mr-2 mb-1 rightsideclose text-truncate d-flex"
               [removable]="removable" (removed)="removeChip(company, 'company')"
              [ngClass]="{ 'bg-ai-chip': company.isSuggested, 'bg-chip': !company.isSuggested, 'excluded-chip': company.isExcluded }"
              *ngFor="let company of companySelectedList">
               <span matChipRemove  class="mr-1">
              <i class="far fa-times f-12" style="margin-left: 0px; margin-top: 1px;"></i>
                </span>
              <span
                class="trim-chip text-truncate f-12 font-weight-lighter hoverable-element d-flex align-items-center">
                <span>
                  <span class="compnaylogoplaceholder-chip">
                    <img [src]="company?.companylogo" *ngIf="company?.companylogo" class="img-fluid" alt="">
                    <i class="fas fa-building f-12" *ngIf="!company?.companylogo"></i>
                  </span>
                </span>
                <span class="mx-1 chip-text text-truncate" [matTooltip]="company.chipkey | titlecase"
                  [matTooltipClass]="{ 'hire-filter text-black': true }" matTooltipPosition="above">{{company.chipkey |
                  titlecase}}</span>
                <mat-icon *ngIf="company.isExcluded" class="f-14 mr--5 text-danger" matTooltip="Excluded"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fas fa-minus-circle pointer"
                    (click)="excludeFilterItem(company.key,'company')"></i></mat-icon>
                <mat-icon *ngIf="!company.isExcluded" class="f-14 mr--5" matTooltip="Exclude"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="far fa-minus-circle pointer"
                    (click)="excludeFilterItem(company.key,'company')"></i></mat-icon>
              </span>
            </mat-chip-row>
          </mat-chip-grid>

          <div class="position-relative">
            <input data-testid="auto-person-search-filter-input-12" class="wc-form-control no-shadow w-100 inputheight mb-2" placeholder="eg. Amazon, Google, etc"
              #trigger="matAutocompleteTrigger" [formControl]="companyInput"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (click)="typeAheadSearch($event, 'company')"
              (keyup)="onTypeAheadSearch($event, 'company')"
              (keyup.enter)="addToSelectedList($event.target.value,'company', 'enter');$event.target.blur();trigger.closePanel()"
              [matAutocomplete]="company_auto" [matChipInputFor]="company_chipList" [matChipInputAddOnBlur]="addOnBlur"
              (blur)="removeTypeahead('company')">
            <div *ngIf="showCompanyLoader" class=" spinner-border position-absolute text-black"
              style="top:13px; right: 7px;" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <mat-autocomplete #company_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'company')">
              <mat-option *ngFor="let comp of companyList"
                [value]="{key: comp.key, doc_count: comp.doc_count, companylogo:comp?.companylogo}"
                [matTooltip]="comp.key | titlecase" [matTooltipClass]="{ 'hire-filter text-black': true }"
                matTooltipPosition="above">
                <span class="d-flex align-items-center">
                  <span class="compnaylogoplaceholder mr-2"
                    [ngClass]="{'bg-white': comp?.companylogo , 'bg-color-company': !comp?.companylogo}">
                    <img [src]="comp?.companylogo" *ngIf="comp?.companylogo" class="img-fluid" alt="">
                    <i class="fas fa-building f-12" *ngIf="!comp?.companylogo"></i>
                  </span>
                  <span class="text-truncate">{{comp.key | titlecase}}</span>
                  <!-- <span class="f-12 text-9696"> ({{comp.doc_count}})</span> -->
                </span>
              </mat-option>
            </mat-autocomplete>
            <div class="d-flex flex-column" *ngIf="!shouldShowSuggestions() || isCalledFromComponent == 'ai-sourcing'">
              <div *ngIf="!showCompanyAiSuggestions || isCalledFromComponent == 'ai-sourcing'">
                <span class="trim-chip  underline-on-hover mb-2 ml-1 d-flex align-items-center"
                  *ngFor="let c of companyTopList" (click)="addToSelectedList(c,'company')"
                  [matTooltip]="c.key | titlecase" [matTooltipClass]="{ 'hire-filter text-black': true }"
                  matTooltipPosition="above">
                  <span>
                    <span class="compnaylogoplaceholder mr-1"
                      [ngClass]="{'bg-white': c?.companylogo , 'bg-color-company': !c?.companylogo}">
                      <img [src]="c?.companylogo" *ngIf="c?.companylogo" class="img-fluid" alt="">
                      <i class="fas fa-building f-12" *ngIf="!c?.companylogo"></i>
                    </span>
                  </span>
                  <span class="text-truncate">{{c.key | titlecase}}</span>
                  <span class="f-12 text-9696">({{c.doc_count | number:'1.0':'en-US'}})</span>
                </span>
              </div>

              <!-- ai suggestions -->
              <div
                *ngIf="showCompanyAiSuggestions && companyAiSuggestions.length && isCalledFromComponent != 'ai-sourcing'">
                <div class="pr-2 flex-shrink-0 d-flex align-items-center mb-2">
                  <span style="line-height: 1.9;" class="ai-text-gradient font-weight-500 ml-1">
                    <i class="fa fa-stars"></i>
                    Similar Companies
                  </span>
                </div>

                <div *ngFor="let c of companyAiSuggestions" class="d-flex flex-column"
                  (click)="addToSelectedList(c,'company')">
                  <div class="d-flex align-items-center mb-2 pointer">
                    <mat-icon class="leading_icon">add</mat-icon>
                    <span class="compnaylogoplaceholder mr-1"
                      [ngClass]="{'bg-white': c?.companylogo , 'bg-color-company': !c?.companylogo}">
                      <img [src]="c?.companylogo" *ngIf="c?.companylogo" class="img-fluid" alt="">
                      <i class="fas fa-building f-12" *ngIf="!c?.companylogo"></i>
                    </span>
                    <span class="text-truncate">{{c.chipkey | titlecase}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Company Size -->
      <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.COMPANY_SIZE)">
        <div class="card-header" id="headingFive">
          <h5 class="mb-0 f-14">
            <div class="px-0 w-100">
              <div class="f-14 w-100">
                <div class="d-flex w-100 align-items-baseline">
                  <button data-testid="auto-person-search-filter-button-11" (click)="!shouldShowSuggestions() && toggleFilter('company_size')"
                    id="collapseFiveBtn" [ngClass]="{'collapsed': companysize?.length == 0}"
                    class="static font-weight-500 text-left flex-grow-1 btn f-14 ml--7" type="button"
                     aria-bs-expanded="false" data-bs-target="#collapseFive" data-bs-toggle="collapse"
                    aria-bs-controls="collapseFive"> Company Size </button>
                  <span class="toggle mr-5" style="flex-shrink: 0;">
                    <div class="down">
                      <span *ngIf="companysize.length > 0" class="red-dot" style="left: 130px;">&bull;</span>
                    </div>
                  </span>
                  <span class="toggle ml-auto mr-5" style="flex-shrink: 0;">
                    <div class="up">
                      <div class="d-flex align-items-center mb-2">
                        <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex"
                          (click)="clearFilters('companysize')">
                          Reset
                        </span>
                          </div>
                    </div>
                  </span>
                  <label for="collapseFiveBtn" class="toggle text-webbtree-green">
                    <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                    <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                  </label>
                </div>
              </div>
            </div>
          </h5>
        </div>

        <div id="collapseFive" class="collapse mb-2 company-seniority" [class.show]="isExpanded('company_size', companysize)"
          aria-bs-labelledby="headingFive">
          <div [ngClass]="{'mb-2': companysize?.length > 0}">
            <mat-chip-set #companysize_chipList *ngIf="!companysize.includes('All')">
              <mat-chip class="mr-2 my-1 rightsideclose text-truncate" [removable]="removable"
                style="background-color: #e4f1f3;" *ngFor="let cs of companysize">
                 <span matChipRemove  class="mr-1">
                  <i class="far fa-times f-12 font-weight-lighter" style="margin-left: 1px;
                      margin-top: 5px;" (click)="removeChip(cs, 'companysize')"></i>
                </span>
                <span
                  class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center font-weight-lighter">
                  <span class="mx-1" [matTooltip]="cs | titlecase" [matTooltipClass]="{ 'hire-filter text-black': true }"
                    matTooltipPosition="above">{{cs}}</span>
                </span>
              </mat-chip>
            </mat-chip-set>

            <mat-chip-set #companysize_chipList>
              <mat-chip class="mr-2 my-1 rightsideclose text-truncate green-chip" [removable]="removable"
                style="background-color: #e4f1f3;" *ngIf="companysize.includes('All')">
                  <span matChipRemove  class="mr-1">
                   <i class="far fa-times f-12 font-weight-lighter" style="margin-left: 1px;
                      margin-top: 5px;" (click)="removeChip('All', 'companysize')"></i>
                </span>
                <span
                  class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center font-weight-lighter">
                  <span class="mx-1">All</span>
                </span>
              </mat-chip>
            </mat-chip-set>
          </div>
           <div class="advsearchpinput">
          <p-multiSelect [options]="companySizeOption" [(ngModel)]="companysize"
            (onChange)="selectedItem($event, 'companysize')" placeholder="Select Company Size" optionLabel="name"
            [filter]="false">
            <ng-template let-value pTemplate="selectedItems">
                    <span *ngIf="value?.length">
                      {{ value.length }} selected
                    </span>
                  </ng-template>
            <!-- <ng-template let-value pTemplate="selectedItems">
              <div>Select Company Size</div>
            </ng-template> -->
             <ng-template pTemplate="header">
                    <div class="d-flex align-items-center row-reverse" style="position: absolute!important; left: 36px!important;">
                      <div class="p-multiselect-header-checkbox">
                        <span class="p-checkbox-label">All</span>
                      </div>
                    </div>
                  </ng-template>
            <ng-template let-cs pTemplate="item">
              <div class="flex align-items-center gap-2">
                <div>{{ cs }}</div>
              </div>
            </ng-template>
          </p-multiSelect>
          </div>
        </div>
      </div>

      <!-- Industries -->
      <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.INDUSTRIES)">
        <div class="card-header" id="headingSix">
          <h5 class="mb-0 f-14">
            <div class="px-0 w-100">
              <div class="f-14 w-100">
                <div class="d-flex w-100 align-items-baseline">
                  <button data-testid="auto-person-search-filter-button-12" (click)="!shouldShowSuggestions() && toggleFilter('industries')"
                    id="collapseSixBtn" [ngClass]="{'collapsed': industrySelectedList?.length == 0}"
                    class="static font-weight-500 text-left flex-grow-1 btn f-14 ml--7" type="button" data-bs-target="#collapseSix" data-bs-toggle="collapse"
                    aria-bs-expanded="false" aria-bs-controls="collapseSix">
                    Industries
                  </button>
                  <span class="toggle mr-5" style="flex-shrink: 0;">
                    <div class="down">
                      <span *ngIf="industrySelectedList.length" class="red-dot" style="left: 95px;">&bull;</span>
                    </div>
                  </span>
                  <span class="toggle ml-auto mr-5" style="flex-shrink: 0;">
                    <div class="up">
                      <div class="d-flex align-items-center mb-2">
                        <div class="mr-2" *ngIf="shouldShowStatus()">
                          <select data-testid="auto-person-search-filter-select-4" name="industryStatus" (change)="filterByStatus($event, 'industry')"
                            [(ngModel)]="industryStatus" class="new-form no-shadow wc-select f-12">
                            <option value="Current" selected>Current</option>
                            <option value="Current or Past">Current or Past</option>
                            <option value="Past">Past</option>
                          </select>
                        </div>
                        <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex"
                          (click)="clearFilters('industry')" *ngIf="industrySelectedList.length">
                          Reset
                        </span>
                      </div>
                    </div>
                  </span>
                  <label for="collapseSixBtn" class="toggle text-webbtree-green">
                    <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                    <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                  </label>
                </div>
              </div>
            </div>
          </h5>
        </div>

        <div id="collapseSix" class="collapse mb-2" [class.show]="isExpanded('industry', industrySelectedList)"
          aria-bs-labelledby="headingSix">

          <mat-chip-grid #industry_chipList>
            <mat-chip-row class="mr-2 mb-1 rightsideclose text-truncate d-flex"
               [removable]="removable" (removed)="removeChip(industry, 'industry')"
              style="background-color: #e4f1f3;" [ngClass]="{'excluded-chip': industry.isExcluded}"
              *ngFor="let industry of industrySelectedList">
              <span matChipRemove  class="mr-1">
                   <i class="far fa-times f-12 font-weight-lighter"></i>
                </span>
              <span
                class="trim-chip text-truncate f-12 font-weight-lighter hoverable-element d-flex align-items-center">

                <span class="mx-1 text-truncate" [matTooltip]="industry.chipkey | titlecase"
                  [matTooltipClass]="{ 'hire-filter text-black': true }" matTooltipPosition="above">{{industry.chipkey |
                  titlecase}}
                </span>
                <mat-icon *ngIf="industry.isExcluded" class="f-12 mr--5 mt-1 text-danger" matTooltip="Excluded"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fas fa-minus-circle pointer"
                    (click)="excludeFilterItem(industry.key,'industry')"></i></mat-icon>
                <mat-icon *ngIf="!industry.isExcluded" matTooltip="Exclude"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }" class="f-12 mr--5 mt-1"><i
                    class="far fa-minus-circle pointer"
                    (click)="excludeFilterItem(industry.key,'industry')"></i></mat-icon>
              </span>
            </mat-chip-row>
          </mat-chip-grid>
          <div class="position-relative">
            <input data-testid="auto-person-search-filter-input-13" class="wc-form-control no-shadow w-100 inputheight mb-2" #trigger="matAutocompleteTrigger"
              placeholder="eg. Information Technology, Banking, etc" [formControl]="industryInput"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (click)="typeAheadSearch($event, 'industry')"
              (keyup)="onTypeAheadSearch($event, 'industry')"
              (keyup.enter)="addToSelectedList($event.target.value,'industry', 'enter');$event.target.blur();trigger.closePanel()"
              [matAutocomplete]="industry_auto" [matChipInputFor]="industry_chipList"
              [matChipInputAddOnBlur]="addOnBlur" (blur)="removeTypeahead('industry')">
            <div *ngIf="showIndustryLoader" class=" spinner-border position-absolute text-black"
              style="top:13px; right: 7px;" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <mat-autocomplete #industry_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'industry')">
              <mat-option *ngFor="let industry of industryList"
                [value]="{key: industry.value, doc_count: industry.doc_count}" [matTooltip]="industry.value | titlecase"
                [matTooltipClass]="{ 'hire-filter text-black': true }" matTooltipPosition="above">
                <span class="d-flex align-items-center">
                  <span class="text-truncate">{{industry.value | titlecase}} </span>
                  <!-- <span class="f-12 text-9696"> ({{industry.doc_count}})</span> -->
                </span>
              </mat-option>
            </mat-autocomplete>
            <div class="d-flex flex-column">
              <span class="trim-chip underline-on-hover mb-2 ml-1 d-flex" *ngFor="let jt of industryTopList"
                (click)="addToSelectedList(jt,'industry')" [matTooltip]="jt.key | titlecase"
                [matTooltipClass]="{ 'hire-filter text-black': true }" matTooltipPosition="above">
                <span class="text-truncate">{{jt.key | titlecase}}</span>
                <!-- <span class="f-12 text-9696 ml-1">({{jt.doc_count | number:'1.0':'en-US'}})</span> -->
              </span>
            </div>
          </div>

        </div>
      </div>

      <!-- Functions -->
      <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.FUNCTIONS)">
        <div class="card-header" id="headingEighteen">
          <h5 class="mb-0 f-14">
            <div class="px-0 w-100">
              <div class="f-14 w-100">
                <div class="d-flex w-100 align-items-baseline">
                  <button data-testid="auto-person-search-filter-button-13" (click)="!shouldShowSuggestions() && toggleFilter('function')"
                    id="collapseEighteenBtn" [ngClass]="{'collapsed': functionSelectedList?.length == 0}"
                    class="static collapsed font-weight-500 text-left flex-grow-1 btn f-14 ml--7" type="button"
                     aria-bs-expanded="false" data-bs-toggle="collapse" data-bs-target="#collapseEighteen"
                    aria-bs-controls="collapseEighteen"> Functions
                  </button>
                  <span class="toggle mr-5" style="flex-shrink: 0;">
                    <div class="down">
                      <span *ngIf="functionSelectedList?.length" class="red-dot">&bull;</span>
                    </div>
                  </span>
                  <span class="toggle ml-auto mr-5" style="flex-shrink: 0;">
                    <div class="up">
                      <div class="d-flex align-items-center mb-2">
                        <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex"
                          (click)="clearFilters('functions')" *ngIf="functionSelectedList?.length">
                          Reset
                        </span>
                      </div>
                    </div>
                  </span>
                  <label for="collapseEighteenBtn" class="toggle text-webbtree-green">
                    <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                    <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                  </label>
                </div>
              </div>
            </div>
          </h5>
        </div>

        <div id="collapseEighteen" class="collapse mb-2" [class.show]="isExpanded('function', functionSelectedList)"
          aria-bs-labelledby="headingEighteen">
          <mat-chip-grid #functions_chipList>
            <mat-chip-row class="mr-2 mb-1 rightsideclose text-truncate d-flex"
               [removable]="removable" (removed)="removeChip(fun, 'functions')"
              style="background-color: #e4f1f3;" *ngFor="let fun of functionSelectedList">
              <i class="far fa-times f-12 font-weight-lighter" matChipRemove></i>

                       <span
                class="trim-chip text-truncate f-12 font-weight-lighter hoverable-element d-flex align-items-center">
                <span class="mx-1 chip-text text-truncate" [matTooltip]="fun.tooltipText"
                  [matTooltipClass]="{ 'hire-filter text-black': true }" matTooltipPosition="above">{{fun?.chipkey?.replaceAll('_',' ') |
                  titlecase}}</span>
                <mat-icon *ngIf="fun.isExcluded" class="f-14 mr--5 text-danger" matTooltip="Excluded"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fas fa-minus-circle pointer"
                    (click)="excludeFilterItem(fun.key,'functions')"></i></mat-icon>
                <mat-icon *ngIf="!fun.isExcluded" class="f-14 mr--5" matTooltip="Exclude"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="far fa-minus-circle pointer"
                    (click)="excludeFilterItem(fun.key,'functions')"></i></mat-icon>
              </span>
            </mat-chip-row>
          </mat-chip-grid>
          <div class="position-relative">
            <input data-testid="auto-person-search-filter-input-14" class="wc-form-control no-shadow w-100 inputheight mb-2" #trigger="matAutocompleteTrigger"
              placeholder="eg. Sociology, Engineering, etc" [formControl]="functionsInput"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (click)="typeAheadSearch($event, 'functions')"
              (keyup)="onTypeAheadSearch($event, 'functions')" [matAutocomplete]="functions_auto"
              [matChipInputFor]="functions_chipList" [matChipInputAddOnBlur]="addOnBlur"
              (blur)="removeTypeahead('functions')">
            <div *ngIf="showFieldOfStudyLoader" class=" spinner-border position-absolute text-black"
              style="top:13px; right: 7px;" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <mat-autocomplete #functions_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'function')">
              <mat-option *ngFor="let fun of functionsList" [value]="{key: fun.value, doc_count: fun.doc_count, function_type: fun.type, parent_function: fun.function}"
                [matTooltip]="fun.value.replaceAll('_', ' ') | titlecase" [matTooltipClass]="{ 'hire-filter text-black': true }"
                matTooltipPosition="above">
                <span class="d-flex align-items-center">
                  <span class="text-truncate">{{fun.value.replaceAll('_', ' ') | titlecase}}</span>
                  <span class="f-12 text-9696 float-right ml-auto">{{fun?.type | titlecase}}</span>
                </span>
              </mat-option>
            </mat-autocomplete>
            <div class="d-flex flex-column" *ngIf="!shouldShowSuggestions()">
              <span class="trim-chip underline-on-hover mb-2 ml-1 d-flex" *ngFor="let jt of functionTopList"
                (click)="addToSelectedList(jt,'function')" [matTooltip]="jt.key | titlecase"
                [matTooltipClass]="{ 'hire-filter text-black': true }" matTooltipPosition="above">
                <span class="text-truncate">{{jt.key.replaceAll('_', ' ') | titlecase}}</span>
                <span class="f-12 text-9696 ml-1">({{jt.doc_count | number:'1.0':'en-US'}})</span>
              </span>
            </div>
          </div>

        </div>
      </div>

      <!--Seniority-->
      <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.SENIORITY)">
        <div class="card-header" id="headingNineteen">
          <h5 class="mb-0 f-14">
            <div class="px-0 w-100">
              <div class="f-14 w-100">
                <div class="d-flex w-100 align-items-baseline">
                  <button data-testid="auto-person-search-filter-button-14" (click)="!shouldShowSuggestions() && toggleFilter('seniority')"
                    id="collapseNineteenBtn" [ngClass]="{'collapsed': seniority?.length == 0}"
                    class="static collapsed font-weight-500 text-left flex-grow-1 btn f-14 ml--7" type="button"
                    data-bs-toggle="collapse" data-bs-target="#collapseNineteen" aria-bs-expanded="false"
                    aria-bs-controls="collapseNineteen"> Seniority </button>
                  <span class="toggle mr-5" style="flex-shrink: 0;">
                    <div class="down">
                      <span *ngIf="seniority?.length > 0" class="red-dot">&bull;</span>
                    </div>
                  </span>
                  <span class="toggle ml-auto mr-5" style="flex-shrink: 0;">
                    <div class="up">
                      <div class="d-flex align-items-center mb-2">
                        <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex"
                          (click)="clearFilters('seniority')">
                          Reset
                        </span>
                      </div>
                    </div>
                  </span>
                  <label for="collapseNineteenBtn" class="toggle text-webbtree-green">
                    <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                    <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                  </label>
                </div>
              </div>
            </div>
          </h5>
        </div>

        <div id="collapseNineteen" class="collapse mb-2 company-seniority" [class.show]="isExpanded('seniority', seniority)"
          aria-labelledby="headingNineteen">
          <div [ngClass]="{'mb-2':seniority?.length>0}">
            <mat-chip-set #seniority__chipList *ngIf="!seniority?.includes('All')">
              <mat-chip class="mr-2 my-1 rightsideclose text-truncate green-chip" [removable]="removable"
                style="background-color: #e4f1f3;" *ngFor="let cs of seniority">
                <span matChipRemove  class="mr-1">
                  <i class="far fa-times f-12 font-weight-lighter" style="margin-left: 1px;
                    margin-top: 5px;" (click)="removeChip(cs, 'seniority')"></i>
                </span>
                <span
                  class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center font-weight-lighter">
                  <span class="mx-1" [matTooltip]="cs | titlecase" [matTooltipClass]="{ 'hire-filter text-black': true }"
                    matTooltipPosition="above">{{cs | titlecase}}</span>
                </span>
              </mat-chip>
            </mat-chip-set>

            <mat-chip-set #seniority__chipList>
              <mat-chip class="mr-2 my-1 rightsideclose text-truncate green-chip" [removable]="removable"
                style="background-color: #e4f1f3;" *ngIf="seniority?.includes('All')">
                <span matChipRemove  class="mr-1">
                  <i class="far fa-times f-12 font-weight-lighter" style="margin-left: 1px;
                    margin-top: 5px;" (click)="removeChip('All', 'seniority')"></i>
                </span>
                <span
                  class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center font-weight-lighter">
                  <span class="mx-1">All</span>
                </span>
              </mat-chip>
            </mat-chip-set>
          </div>
          <div class="advsearchpinput">
          <p-multiSelect [options]="seniorityList" [(ngModel)]="seniority"
            (onChange)="selectedItem($event, 'seniority')" placeholder="Select Seniority" optionLabel="name"
            [filter]="false">
            <ng-template let-value pTemplate="selectedItems">
                    <span *ngIf="value?.length">
                      {{ value.length }} selected
                    </span>
                  </ng-template>
            <ng-template pTemplate="header">
                    <div class="d-flex align-items-center row-reverse" style="position: absolute!important; left: 36px!important;">
                      <div class="p-multiselect-header-checkbox">
                        <span class="p-checkbox-label">All</span>
                      </div>
                    </div>
                  </ng-template>
            <ng-template let-cs pTemplate="item">
              <div class="flex align-items-center gap-2">
                <div>{{ cs | titlecase }}</div>
              </div>
            </ng-template>
          </p-multiSelect>
          </div>
        </div>
      </div>

      <!-- Years of Experience -->
      <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.YOE)">
        <div class="card-header" id="headingSeven">
          <h5 class="mb-0 f-14">
            <div class="px-0 w-100">
              <div class="f-14 w-100">
                <div class="d-flex w-100 align-items-baseline">
                  <button data-testid="auto-person-search-filter-button-15" (click)="!shouldShowSuggestions() && toggleFilter('yearsofexperience')"
                    id="collapseSevenBtn" [ngClass]="{'collapsed': !filterAppliedOnYearsOfExperience}"
                    class="static font-weight-500 text-left flex-grow-1 btn f-14 ml--7" type="button"
                   aria-bs-expanded="false" data-bs-target="#collapseSeven" data-bs-toggle="collapse"
                    aria-bs-controls="collapseSeven"> Years of Experience </button>
                  <span class="toggle mr-5" style="flex-shrink: 0;">
                    <div class="down">
                      <span *ngIf="filterAppliedOnYearsOfExperience" class="red-dot" style="left: 165px;">&bull;</span>
                    </div>
                  </span>
                  <span class="toggle ml-auto mr-5" style="flex-shrink: 0;"
                    *ngIf="isCalledFromComponent !== 'ai-sourcing'">
                    <div class="up">
                      <select data-testid="auto-person-search-filter-select-5" name="yearsofexperience" (change)="filterByStatus($event, 'yearsofexperience')"
                        [(ngModel)]="yearsofexperience" class="new-form no-shadow wc-select f-12">
                        <option value="Total" selected>Total</option>
                        <option value="Average">Average</option>
                      </select>
                    </div>
                  </span>
                  <label for="collapseSevenBtn" class="toggle text-webbtree-green">
                    <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                    <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                  </label>
                </div>
              </div>
            </div>
          </h5>
        </div>

        <div id="collapseSeven" class="collapse mb-2" [class.show]="isExpanded('yearsofexperience', filterAppliedOnYearsOfExperience)"
          aria-bs-labelledby="headingSeven">
          <div class="d-flex align-items-center mb-2">
          </div>
          <div class="d-flex align-items-center ml-2 w-100">
            <label class="f-14 text-black mr-2">From</label>
            <input data-testid="auto-person-search-filter-input-15" class="wc-form-control no-shadow inputheight mb-2 mr-3 w-25" type="number" min="0" required
              onwheel="this.blur()" [formControl]="yearsofexperienceFrom" placeholder="eg. 1, 2" style="z-index: 1;">
            <label class="f-14 text-black mr-2">To</label>
            <input data-testid="auto-person-search-filter-input-16" class="wc-form-control no-shadow inputheight mb-2 w-25" type="number" min="0" required
              onwheel="this.blur()" [formControl]="yearsofexperienceTo" placeholder="eg. 1, 2" style="z-index: 1;">
          </div>
          <p *ngIf="hasYearsOfExperInsightsRangeError?.error" class="f-12 text-danger text-center">
            {{hasYearsOfExperInsightsRangeError?.message}}</p>

          <div class="col position-relative wccard" *ngIf="dataSourceYearsOfExperience">
            <div>
              <div class="loader" *ngIf="!dataSourceYearsOfExperience">
                <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
              </div>
              <fusioncharts width="100%" height="250" type="spline" [dataSource]="dataSourceYearsOfExperience"
                *ngIf="dataSourceYearsOfExperience && dataSourceYearsOfExperience?.data?.length">
              </fusioncharts>
            </div>
            <div class="d-flex justify-content-end align-items-center">
              <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex mr-4"
                (click)="clearFilters('yearsofexperience')">
                Reset
              </span>
              <button data-testid="auto-person-search-filter-button-16" class="m-0" (click)="applyFilter('yearsofexperience')"
                [disabled]="hasYearsOfExperInsightsRangeError?.error"
                [ngClass]="hasYearsOfExperInsightsRangeError?.error ? 'disabled-btn-experience' : 'btn-trms-xs-small'">Apply</button>
            </div>
          </div>
          <!-- <div class="d-flex justify-content-end align-items-center" *ngIf="isCalledFromComponent == 'ai-sourcing'">
                <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex mr-4"
                    (click)="clearFilters('yearsofexperience')">
                    Reset
                </span>
                <button data-testid="auto-person-search-filter-button-17" class="btn-trms-xs-small m-0" (click)="applyFilter('yearsofexperience')"
                    [disabled]="getYearsOfExperienceValidation()"
                    [ngClass]="getYearsOfExperienceValidation() ? 'disabled-btn-experience' : 'btn-trms-xs-small'">Apply</button>
            </div> -->
        </div>
      </div>

      <!-- Years In Current Company    -->
      <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.YOE_CURRENT_COMPANY)">
        <div class="card-header" id="headingSevenCurrent">
          <h5 class="mb-0 f-14">
            <div class="px-0 w-100">
              <div class="f-14 w-100">
                <div class="d-flex w-100 align-items-baseline">
                  <button data-testid="auto-person-search-filter-button-18" (click)="toggleFilter('currentyearsofexperience')" id="collapeSevenCurrentBtn"
                    [ngClass]="{'collapsed': !filterAppliedOnCurrentYearsOfExperience}"
                    class="static font-weight-500 text-left flex-grow-1 btn f-14 ml--7" type="button"
                     aria-bs-expanded="false" data-bs-target="#collapeSevenCurrent" data-bs-toggle="collapse"
                    aria-bs-controls="collapeSevenCurrent"> Years In Current Company
                  </button>
                  <span class="toggle mr-5" style="flex-shrink: 0;">
                    <div class="down">
                      <span *ngIf="filterAppliedOnCurrentYearsOfExperience" class="red-dot"
                        style="left: 210px;">&bull;</span>
                    </div>
                  </span>
                  <label for="collapeSevenCurrentBtn" class="toggle text-webbtree-green">
                    <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                    <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                  </label>
                </div>
              </div>
            </div>
          </h5>
        </div>

        <div id="collapeSevenCurrent" class="collapse mb-2"
          [class.show]="isExpanded('currentyearsofexperience', filterAppliedOnCurrentYearsOfExperience)" aria-bs-labelledby="headingSevenCurrent">
          <div class="d-flex align-items-center mb-2">
          </div>
          <div class="d-flex align-items-center ml-2 w-100">
            <label class="f-14 text-black mr-2">From</label>
            <input data-testid="auto-person-search-filter-input-17" class="wc-form-control no-shadow inputheight mb-2 mr-3 w-25" type="number" min="0" required
              onwheel="this.blur()" [formControl]="currentfromyearsofexperience" placeholder="eg. 1, 2"
              style="z-index: 1;">
            <label class="f-14 text-black mr-2">To</label>
            <input data-testid="auto-person-search-filter-input-18" class="wc-form-control no-shadow inputheight mb-2 w-25" type="number" min="1" required
              onwheel="this.blur()" [formControl]="currenttoyearsofexperience" placeholder="eg. 1, 2"
              style="z-index: 1;">
          </div>
          <p *ngIf="(currenttoyearsofexperience.value ==0) && (currentfromyearsofexperience.value != null && currenttoyearsofexperience.value != null) && (currentfromyearsofexperience.value > currenttoyearsofexperience.value) && !(currentfromyearsofexperience.value < 0 || currentfromyearsofexperience.value > 40 || currenttoyearsofexperience.value > 40 || currenttoyearsofexperience < 0)"
            class="f-12 text-danger text-center"> Invalid Input </p>
          <p *ngIf="(currentfromyearsofexperience.value < 0 || currentfromyearsofexperience.value > 40 || currenttoyearsofexperience.value > 40 || currenttoyearsofexperience < 0)"
            class="f-12 text-danger text-center"> Enter a valid number in the range (0 – 40)</p>

          <div class="col position-relative wccard" *ngIf="dataSourceCurrentYearsOfExperience">
            <div>
              <div class="loader" *ngIf="!dataSourceCurrentYearsOfExperience?.data?.length">
                <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
              </div>
              <fusioncharts width="100%" height="250" type="spline" [dataSource]="dataSourceCurrentYearsOfExperience"
                *ngIf="dataSourceCurrentYearsOfExperience && dataSourceCurrentYearsOfExperience?.data?.length">
              </fusioncharts>
            </div>
            <div class="d-flex justify-content-end align-items-center">
              <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex mr-4"
                (click)="clearFilters('currentyearsofexperience')">
                Reset
              </span>
              <!-- <button data-testid="auto-person-search-filter-button-19" class="btn reset-btn btn-sm mr-2" (click)="clearFilters('yearsofexperience')">Reset</button> -->
              <button data-testid="auto-person-search-filter-button-20" class="btn-trms-xs-small m-0" (click)="applyFilter('currentyearsofexperience')"
                [disabled]="getCurrentYearsValidation()"
                [ngClass]="getCurrentYearsValidation() ? 'disabled-btn-experience' : 'btn-trms-xs-small'">Apply</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Gender -->
      <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.GENDER)">
        <div class="card-header" id="headingTen">
          <h5 class="mb-0 f-14">
            <div class="px-0 w-100">
              <div class="f-14 w-100">
                <div class="d-flex w-100 align-items-baseline">
                  <button data-testid="auto-person-search-filter-button-21" (click)="!shouldShowSuggestions() && toggleFilter('gender')" id="collapseTenBtn"
                    [ngClass]="{'collapsed': gender == 'All'}"
                    class="static font-weight-500 text-left flex-grow-1 btn f-14 ml--7" type="button"
                    aria-bs-expanded="false" data-bs-target="#collapseTen" data-bs-toggle="collapse" aria-bs-controls="collapseTen">
                    Gender
                  </button>
                  <span class="toggle mr-5" style="flex-shrink: 0;">
                    <div class="down">
                      <span *ngIf="isGenderSelected" class="red-dot" style="left: 80px;">&bull;</span>
                    </div>
                  </span>
                  <span class="toggle ml-auto mr-5" style="flex-shrink: 0;">
                    <div class="up">
                      <div class="d-flex align-items-center mb-2">
                        <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex"
                          (click)="clearFilters('gender')">
                          Reset
                        </span>
                      </div>
                    </div>
                  </span>
                  <label for="collapseTenBtn" class="toggle text-webbtree-green">
                    <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                    <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                  </label>
                </div>
              </div>
            </div>
          </h5>
        </div>

        <div id="collapseTen" class="collapse mb-2" [class.show]="isExpanded('gender', gender != 'All')" aria-bs-labelledby="headingTen">
          <select data-testid="auto-person-search-filter-select-6" name="gender" (change)="selectedItem($event, 'gender')" [(ngModel)]="gender"
            class="wc-form-control position-relative no-outline inputheight wc-select"
            [disabled]="isGenderSelectionDisabled">
            <option value="All" selected>All </option>
            <option value="Female">Women</option>
            <option value="Male">Men</option>
          </select>
        </div>
      </div>

      <!-- Education -->
      <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.EDUCATION)">
        <div class="card-header" id="headingTwelve">
          <h5 class="mb-0 f-14">
            <div class="px-0 w-100">
              <div class="f-14 w-100">
                <div class="d-flex w-100 align-items-baseline">
                  <button data-testid="auto-person-search-filter-button-22" (click)="!shouldShowSuggestions() && toggleFilter('education')"
                    id="collapseTwelveBtn" [ngClass]="{'collapsed': educationSelectedList?.length == 0}"
                    class="static font-weight-500 text-left flex-grow-1 btn f-14 ml--7" type="button"
                    aria-bs-expanded="false" data-bs-toggle="collapse" data-bs-target="#collapseTwelve"
                    aria-bs-controls="collapseTwelve"> Education
                  </button>
                  <span class="toggle mr-5" style="flex-shrink: 0;">
                    <div class="down">
                      <span *ngIf="educationSelectedList?.length" class="red-dot" style="left: 100px;">&bull;</span>
                    </div>
                  </span>
                  <span class="toggle ml-auto mr-5" style="flex-shrink: 0;">
                    <div class="up">
                      <div class="d-flex align-items-center mb-2">
                        <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex"
                          (click)="clearFilters('education')" *ngIf="educationSelectedList?.length">
                          Reset
                        </span>
                      </div>
                    </div>
                  </span>
                  <label for="collapseTwelveBtn" class="toggle text-webbtree-green">
                    <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                    <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                  </label>
                </div>
              </div>
            </div>
          </h5>
        </div>

        <div id="collapseTwelve" class="collapse mb-2" [class.show]="isExpanded('education', educationSelectedList?.length > 0)"
          aria-bs-labelledby="headingTwelve">
          <mat-chip-grid #education_chipList>
            <mat-chip-row class="mr-2 mb-1 rightsideclose text-truncate d-flex"
               [removable]="removable" (removed)="removeChip(education, 'education')"
              style="background-color: #e4f1f3;" *ngFor="let education of educationSelectedList">
              <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 font-weight-lighter"></i>
              </span>
              <span class="trim-chip text-truncate f-12 font-weight-lighter"
                [matTooltip]="education.chipkey | titlecase" [matTooltipClass]="{ 'hire-filter text-black': true }"
                matTooltipPosition="above">{{education.chipkey | titlecase}}
              </span>
            </mat-chip-row>
          </mat-chip-grid>

          <div class="position-relative">
            <input data-testid="auto-person-search-filter-input-19" class="wc-form-control no-shadow w-100 inputheight mb-2" placeholder="eg. Education"
              [formControl]="educationInput" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (click)="typeAheadSearch($event, 'education')" (keyup)="onTypeAheadSearch($event, 'education')"
              (keyup.enter)="addToSelectedList($event.target.value,'education', 'enter');$event.target.blur();trigger.closePanel()"
              [matAutocomplete]="education_auto" [matChipInputFor]="education_chipList"
              [matChipInputAddOnBlur]="addOnBlur" (blur)="removeTypeahead('education')">
            <div *ngIf="showEducationLoader" class=" spinner-border position-absolute text-black"
              style="top:13px; right: 7px;" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <mat-autocomplete #education_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'education')">
              <mat-option *ngFor="let education of educationList"
                [value]="{key: education.value, doc_count: education.doc_count}"
                [matTooltip]="education.value | titlecase" [matTooltipClass]="{ 'hire-filter text-black': true }"
                matTooltipPosition="above">
                <span class="d-flex align-items-center">
                  <span class="text-truncate">{{(education.value) | titlecase}} </span>
                  <!-- <span class="f-12 text-9696"> ({{education.doc_count}})</span> -->
                </span>
              </mat-option>
            </mat-autocomplete>
            <div class="d-flex flex-column" *ngIf="!shouldShowSuggestions()">
              <span class="trim-chip  underline-on-hover mb-2 ml-1 d-flex" *ngFor="let jt of educationTopList"
                (click)="addToSelectedList(jt,'education')" [matTooltip]="jt.key | titlecase"
                [matTooltipClass]="{ 'hire-filter text-black': true }" matTooltipPosition="above">
                <span class="text-truncate">{{jt.key | titlecase}}</span>
                <span class="f-12 text-9696 ml-1">({{jt.doc_count | number:'1.0':'en-US'}})</span>
              </span>
            </div>
          </div>

        </div>
      </div>

      <!-- Education Location  -->
      <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.EDUCATION_LOCATION)">
        <div class="card-header" id="headingTwelveschoollocation">
          <h5 class="mb-0 f-14">
            <div class="px-0 w-100">
              <div class="f-14 w-100">
                <div class="d-flex w-100 align-items-baseline">
                  <button data-testid="auto-person-search-filter-button-23" (click)="toggleFilter('schoollocation')" id="schoollocationBtn"
                    [ngClass]="{'collapsed': schoolLocationSelectedList?.length == 0}"
                    class="static font-weight-500 text-left flex-grow-1 btn f-14 ml--7" type="button"
                    aria-bs-expanded="false" data-bs-toggle="collapse" data-bs-target="#schoollocation"
                    aria-bs-controls="schoollocation"> Education Location
                  </button>
                  <span class="toggle mr-5" style="flex-shrink: 0;">
                    <div class="down">
                      <span *ngIf="schoolLocationSelectedList.length" class="red-dot" style="left: 160px;">&bull;</span>
                    </div>
                  </span>
                  <span class="toggle ml-auto mr-5" style="flex-shrink: 0;">
                    <div class="up">
                      <div class="d-flex align-items-center mb-2">
                        <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex"
                          (click)="clearFilters('schoollocation')" *ngIf="schoolLocationSelectedList.length">
                          Reset
                        </span>
                      </div>
                    </div>
                  </span>
                  <label for="schoollocationBtn" class="toggle text-webbtree-green">
                    <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                    <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                  </label>
                </div>
              </div>
            </div>
          </h5>
        </div>

        <div id="schoollocation" class="collapse mb-2" [class.show]="isExpanded('schoollocation', schoolLocationSelectedList?.length > 0)"
          aria-bs-labelledby="headingTwelveschoollocation">
          <mat-chip-grid #schoollocation_chipList>
            <mat-chip-row class="mr-2 mb-1 rightsideclose text-truncate d-flex"
               [removable]="removable" (removed)="removeChip(cl, 'schoollocation')"
              style="background-color: #e4f1f3;" [ngClass]="{'excluded-chip': cl.isExcluded}"
              *ngFor="let cl of schoolLocationSelectedList">
              <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 font-weight-lighter"></i>
              </span>
              <span
                class="trim-chip text-truncate f-12 font-weight-lighter hoverable-element d-flex align-items-center">
                <span class="mx-1">{{cl.chipkey | titlecase}}</span>
                <mat-icon *ngIf="cl.isExcluded" class="f-14 mr--5 text-danger" matTooltip="Excluded"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fas fa-minus-circle pointer"
                    (click)="excludeFilterItem(cl.key, 'schoollocation')"></i></mat-icon>
                <mat-icon *ngIf="!cl.isExcluded" class="f-14 mr--5" matTooltip="Exclude"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="far fa-minus-circle pointer"
                    (click)="excludeFilterItem(cl.key, 'schoollocation')"></i></mat-icon>
              </span>
            </mat-chip-row>
          </mat-chip-grid>

          <div class="position-relative">
            <input data-testid="auto-person-search-filter-input-20" class="wc-form-control no-shadow w-100 inputheight mb-2" placeholder="Enter Location"
              [formControl]="schoolLocationInput" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (click)="typeAheadSearch($event, 'schoollocation')" (keyup)="onTypeAheadSearch($event, 'schoollocation')"
              (keyup.enter)="addToSelectedList($event.target.value,'schoollocation', 'enter');$event.target.blur();trigger.closePanel()"
              [matAutocomplete]="schoollocation_auto" [matChipInputFor]="schoollocation_chipList"
              [matChipInputAddOnBlur]="addOnBlur" (blur)="removeTypeahead('schoollocation')">
            <div *ngIf="showschoollocationLoader" class=" spinner-border position-absolute text-black"
              style="top:13px; right: 7px;" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <mat-autocomplete #schoollocation_auto="matAutocomplete"
              (optionSelected)="selectedItem($event, 'schoollocation')">
              <mat-option *ngFor="let schoollocation of schoolLocationList"
                [value]="{key: schoollocation.value, doc_count: schoollocation.doc_count}">
                <span class="d-flex align-items-center">
                  <span class="text-truncate">{{(schoollocation.value) | titlecase}} </span>
                  <!-- <span class="f-12 text-9696"> ({{schoollocation.doc_count}})</span> -->
                </span>
              </mat-option>
            </mat-autocomplete>
            <div class="d-flex flex-column">
              <span class="trim-chip  underline-on-hover mb-2 ml-1 d-flex" *ngFor="let jt of schoolLocationTopList"
                (click)="addToSelectedList(jt,'schoollocation')">
                <span class="text-truncate">{{jt.key | titlecase}}</span>
                <span class="f-12 text-9696 ml-1">({{jt.doc_count | number:'1.0':'en-US'}})</span>
              </span>
            </div>
          </div>

        </div>
      </div>

      <!-- School -->
      <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.SCHOOL)">
        <div class="card-header" id="headingFourteen">
          <h5 class="mb-0 f-14">
            <div class="px-0 w-100">
              <div class="f-14 w-100">
                <div class="d-flex w-100 align-items-baseline">
                  <button data-testid="auto-person-search-filter-button-24" (click)="!shouldShowSuggestions() && toggleFilter('school')"
                    id="collapseFourteenBtn" [ngClass]="{'collapsed': schoolSelectedList?.length == 0}"
                    class="static font-weight-500 text-left flex-grow-1 btn f-14 ml--7" type="button"
                    data-bs-target="#collapseFourteen" data-bs-toggle="collapse"
                    aria-bs-expanded="false" aria-bs-controls="collapseFourteen"> School
                  </button>
                  <span class="toggle mr-5" style="flex-shrink: 0;">
                    <div class="down">
                      <span *ngIf="schoolSelectedList?.length" class="red-dot" style="left: 80px;">&bull;</span>
                    </div>
                  </span>
                  <span class="toggle ml-auto mr-5" style="flex-shrink: 0;">
                    <div class="up">
                      <div class="d-flex align-items-center mb-2">
                        <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex"
                          (click)="clearFilters('school')" *ngIf="schoolSelectedList?.length">
                          Reset
                        </span>
                      </div>
                    </div>
                  </span>
                  <label for="collapseFourteenBtn" class="toggle text-webbtree-green">
                    <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                    <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                  </label>
                </div>
              </div>
            </div>
          </h5>
        </div>

        <div id="collapseFourteen" class="collapse mb-2" [class.show]="isExpanded('school', schoolSelectedList?.length > 0)"
          aria-bs-labelledby="headingFourteen">
          <mat-chip-grid #school_chipList>
            <mat-chip-row class="mr-2 mb-1 rightsideclose text-truncate d-flex"
               [removable]="removable" (removed)="removeChip(school, 'school')"
              style="background-color: #e4f1f3;" *ngFor="let school of schoolSelectedList">
              <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 font-weight-lighter"></i>
              </span>
              <span class="trim-chip text-truncate f-12 font-weight-lighter" [matTooltip]="school.chipkey | titlecase"
                [matTooltipClass]="{ 'hire-filter text-black': true }" matTooltipPosition="above">{{school.chipkey |
                titlecase}}
              </span>
            </mat-chip-row>
          </mat-chip-grid>

          <div class="position-relative">
            <input data-testid="auto-person-search-filter-input-21" class="wc-form-control no-shadow w-100 inputheight mb-2" placeholder="eg. School"
              [formControl]="schoolInput" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (click)="typeAheadSearch($event, 'school')" (keyup)="onTypeAheadSearch($event, 'school')"
              (keyup.enter)="addToSelectedList($event.target.value,'school', 'enter');$event.target.blur();trigger.closePanel()"
              [matAutocomplete]="school_auto" [matChipInputFor]="school_chipList" [matChipInputAddOnBlur]="addOnBlur"
              (blur)="removeTypeahead('school')">
            <div *ngIf="showSchoolLoader" class=" spinner-border position-absolute text-black"
              style="top:13px; right: 7px;" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <mat-autocomplete #school_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'school')">
              <mat-option *ngFor="let school of schoolList" [value]="{key: school.value, doc_count: school.doc_count}"
                [matTooltip]="school.value | titlecase" [matTooltipClass]="{ 'hire-filter text-black': true }"
                matTooltipPosition="above">
                <span class="d-flex align-items-center">
                  <span class="text-truncate">{{(school.value) | titlecase}}</span>
                  <!-- <span class="f-12 text-9696"> ({{school.doc_count}})</span> -->
                </span>
              </mat-option>
            </mat-autocomplete>
            <div class="d-flex flex-column" *ngIf="!shouldShowSuggestions()">
              <span class="trim-chip  underline-on-hover mb-2 ml-1 d-flex" *ngFor="let jt of schoolTopList"
                (click)="addToSelectedList(jt,'school')" [matTooltip]="jt.key | titlecase"
                [matTooltipClass]="{ 'hire-filter text-black': true }" matTooltipPosition="above">
                <span class="text-truncate">{{jt.key | titlecase}}</span>
                <span class="f-12 text-9696 ml-1">({{jt.doc_count | number:'1.0':'en-US'}})</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Field Of Study -->
      <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.FIELD_OF_STUDY)">
        <div class="card-header" id="headingFifteen">
          <h5 class="mb-0 f-14">
            <div class="px-0 w-100">
              <div class="f-14 w-100">
                <div class="d-flex w-100 align-items-baseline">
                  <button data-testid="auto-person-search-filter-button-25" (click)="!shouldShowSuggestions() && toggleFilter('field_of_study')"
                    id="collapseFifteenBtn" [ngClass]="{'collapsed': fieldOfStudySelectedList?.length == 0}"
                    class="static font-weight-500 text-left flex-grow-1 btn f-14 ml--7" type="button"
                     aria-bs-expanded="false" data-bs-target="#collapseFifteen" data-bs-toggle="collapse"
                    aria-bs-controls="collapseFifteen"> Field Of Study
                  </button>
                  <span class="toggle mr-5" style="flex-shrink: 0;">
                    <div class="down">
                      <span *ngIf="fieldOfStudySelectedList?.length" class="red-dot" style="left: 125px;">&bull;</span>
                    </div>
                  </span>
                  <span class="toggle ml-auto mr-5" style="flex-shrink: 0;">
                    <div class="up">
                      <div class="d-flex align-items-center mb-2">
                        <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex"
                          (click)="clearFilters('fieldofstudy')" *ngIf="fieldOfStudySelectedList?.length">
                          Reset
                        </span>
                      </div>
                    </div>
                  </span>
                  <label for="collapseFifteenBtn" class="toggle text-webbtree-green">
                    <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                    <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                  </label>
                </div>
              </div>
            </div>
          </h5>
        </div>

        <div id="collapseFifteen" class="collapse mb-2" [class.show]="isExpanded('field_of_study', fieldOfStudySelectedList?.length > 0)"
          aria-bs-labelledby="headingFifteen">
          <mat-chip-grid #fieldofstudy_chipList>
            <mat-chip-row class="mr-2 mb-1 rightsideclose text-truncate d-flex"
               [removable]="removable" (removed)="removeChip(fieldofstudy, 'fieldofstudy')"
              style="background-color: #e4f1f3;" *ngFor="let fieldofstudy of fieldOfStudySelectedList">
              <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 font-weight-lighter"></i>
              </span>
              <span class="trim-chip text-truncate f-12 font-weight-lighter"
                [matTooltip]="fieldofstudy.chipkey | titlecase" [matTooltipClass]="{ 'hire-filter text-black': true }"
                matTooltipPosition="above">{{fieldofstudy.chipkey | titlecase}}
                <!-- <span class="f-12 font-weight-lighter">({{fieldofstudy.doc_count}})</span> -->
              </span>
            </mat-chip-row>
          </mat-chip-grid>
          <div class="position-relative">
            <input data-testid="auto-person-search-filter-input-22" class="wc-form-control no-shadow w-100 inputheight mb-2" #trigger="matAutocompleteTrigger"
              placeholder="eg. Sociology, Engineering, etc" [formControl]="fieldOfStudyInput"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (click)="typeAheadSearch($event, 'fieldofstudy')"
              (keyup)="onTypeAheadSearch($event, 'fieldofstudy')" [matAutocomplete]="fieldofstudy_auto"
              (keyup.enter)="addToSelectedList($event.target.value,'fieldofstudy', 'enter');$event.target.blur();trigger.closePanel()"
              [matChipInputFor]="fieldofstudy_chipList" [matChipInputAddOnBlur]="addOnBlur"
              (blur)="removeTypeahead('fieldofstudy')">
            <div *ngIf="showFieldOfStudyLoader" class=" spinner-border position-absolute text-black"
              style="top:13px; right: 7px;" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <mat-autocomplete #fieldofstudy_auto="matAutocomplete"
              (optionSelected)="selectedItem($event, 'fieldofstudy')">
              <mat-option *ngFor="let fieldofstudy of fieldOfStudyList"
                [value]="{key: fieldofstudy.value, doc_count: fieldofstudy.doc_count}"
                [matTooltip]="fieldofstudy.value | titlecase" [matTooltipClass]="{ 'hire-filter text-black': true }"
                matTooltipPosition="above">
                <span class="d-flex align-items-center">
                  <span class="text-truncate">{{fieldofstudy.value | titlecase}}</span>
                  <!-- <span class="f-12 text-9696"> ({{fieldofstudy.doc_count}})</span> -->
                </span>
              </mat-option>
            </mat-autocomplete>
            <div class="d-flex flex-column" *ngIf="!shouldShowSuggestions()">
              <span class="trim-chip underline-on-hover mb-2 ml-1 d-flex" *ngFor="let jt of fieldOfStudyTopList"
                (click)="addToSelectedList(jt,'fieldofstudy')" [matTooltip]="jt.key | titlecase"
                [matTooltipClass]="{ 'hire-filter text-black': true }" matTooltipPosition="above">
                <span class="text-truncate">{{jt.key | titlecase}}</span>
                <span class="f-12 text-9696 ml-1">({{jt.doc_count | number:'1.0':'en-US'}})</span>
              </span>
            </div>
          </div>

        </div>
      </div>


      <!-- Full Name -->
      <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.FULL_NAME)">
        <div class="card-header" id="headingFullName">
            <h5 class="mb-0 f-14">
                <div class="px-0 w-100">
                    <div class="f-14 w-100" >
                        <div class="d-flex w-100 align-items-baseline">
                            <button data-testid="auto-person-search-filter-button-26" id="collapseFullNameBtn" (click)="toggleFilter('fullname')" [ngClass]="{'collapsed': fullNameSelectedList?.length == 0}" class="static font-weight-500 text-left flex-grow-1 btn f-14 ml--7" type="button" aria-bs-expanded="false" aria-bs-controls="collapseFullName" data-bs-target="#collapseFullName" data-bs-toggle="collapse"> Name
                            </button>
                            <span class="toggle mr-5" style="flex-shrink: 0;">
                                <div class="down">
                                    <span *ngIf="fullNameSelectedList?.length"  class="red-dot" style="left: 125px;">&bull;</span>
                                </div>
                            </span>
                            <span class="toggle ml-auto mr-5" style="flex-shrink: 0;">
                                <div class="up">
                                    <div class="d-flex align-items-center mb-2">
                                        <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex" (click)="clearFilters('fullname')" *ngIf="fullNameSelectedList?.length">
                                           Reset
                                        </span>
                                    </div>
                                </div>
                            </span>
                            <label for="collapseFullNameBtn" class="toggle text-webbtree-green">
                                <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                                <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                            </label>
                        </div>
                    </div>
                </div>
            </h5>
        </div>

        <div id="collapseFullName" class="collapse mb-2" [class.show]="isExpanded('fullname', fullNameSelectedList?.length > 0)" aria-bs-labelledby="headingFullName">
            <mat-chip-grid #fullName_chipList>
                <mat-chip-row class="mr-2 mb-1 rightsideclose text-truncate d-flex"
                    [removable]="removable" (removed)="removeChip(fullName, 'fullname')" style="background-color: #e4f1f3;"
                    *ngFor="let fullName of fullNameSelectedList">
                  <span matChipRemove  class="mr-1">
                    <i class="far fa-times f-12 font-weight-lighter"></i>
                  </span>
                    <span class="trim-chip text-truncate f-12 font-weight-lighter" [matTooltip]="fullName.chipkey | titlecase" [matTooltipClass]="{ 'hire-filter text-black': true }" matTooltipPosition="above">{{fullName.chipkey | titlecase}}
                        <!-- <span class="f-12 font-weight-lighter">({{fieldofstudy.doc_count}})</span> -->
                    </span>
                </mat-chip-row>
            </mat-chip-grid>
            <div class="position-relative">
                <input data-testid="auto-person-search-filter-input-23" class="wc-form-control no-shadow w-100 inputheight mb-2" #trigger="matAutocompleteTrigger"
                    placeholder="eg. firstname, lastname" [formControl]="fullNameInput"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (click)="typeAheadSearch($event, 'fullname')"
                    (keyup)="onTypeAheadSearch($event, 'fullname')" [matAutocomplete]="fullName_auto"
                    (keyup.enter)="addToSelectedList($event.target.value,'fullname', 'enter');$event.target.blur();trigger.closePanel()"
                    [matChipInputFor]="fullName_chipList" [matChipInputAddOnBlur]="addOnBlur" (blur)="removeTypeahead('fullname')">
                    <div *ngIf="showFullNameLoader" class=" spinner-border position-absolute text-black" style="top:13px; right: 7px;" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                <mat-autocomplete #fullName_auto="matAutocomplete"
                    (optionSelected)="selectedItem($event, 'fullname')">
                    <mat-option *ngFor="let fullName of fullNameList" [value]="{key: fullName.value, doc_count: fullName.doc_count}" [matTooltip]="fullName.value | titlecase" [matTooltipClass]="{ 'hire-filter text-black': true }" matTooltipPosition="above">
                        <span class="d-flex align-items-center">
                            <span class="text-truncate">{{fullName.value | titlecase}}</span>
                        </span>
                    </mat-option>
                </mat-autocomplete>
            </div>

        </div>
      </div>



      <!-- Likely To Move In -->
      <!-- <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.LIKELY_TO_MOVE_IN)">
        <div class="card-header" id="headingSeventeen">
          <h5 class="mb-0 f-14">
                <div class="px-0 w-100">
                    <div class="f-14 w-100" >
                        <div class="d-flex w-100 align-items-baseline">
                            <button data-testid="auto-person-search-filter-button-27" (click)="toggleFilter('likely_to_move_in')" id="collapseSeventeenBtn" [ngClass]="{'collapsed': !filterLikelyToMoveIn}" class="static font-weight-500 text-left flex-grow-1 btn f-14 ml--7" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeventeen" aria-expanded="false" aria-controls="collapseSeventeen"> Likely To Move In </button>
                            <span class="toggle mr-5" style="flex-shrink: 0;">
                                <div class="down">
                                     <span *ngIf="filterLikelyToMoveIn !== 'All'"  class="red-dot" style="left: 145px;">&bull;</span>
                                </div>
                            </span>
                            <span class="toggle ml-auto mr-5" style="flex-shrink: 0;">
                                <div class="up">
                                    <div class="d-flex align-items-center mb-2">
                                        <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex" (click)="clearFilters('likelytomovein')">
                                           Reset
                                        </span>
                                    </div>
                                </div>
                            </span>
                            <label for="collapseSeventeenBtn" class="toggle text-webbtree-green">
                                <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                                <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                            </label>
                        </div>
                    </div>
                </div>
            </h5>
        </div>

        <div id="collapseSeventeen" class="collapse mb-2" [ngClass]="{'show': filterLikelyToMoveIn != 'All'}" aria-labelledby="headingSeventeen">

            <select data-testid="auto-person-search-filter-select-7" name="filterLikelyToMoveIn" (change)="selectedItem($event, 'likelytomovein')"
                [(ngModel)]="filterLikelyToMoveIn" class="wc-form-control position-relative no-outline inputheight wc-select">
                <option value="All" selected>All</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
            </select>
        </div>
      </div> -->

      <!-- Keyword -->
      <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.KEYWORD)">
        <div class="card-header" id="headingThirtyNine">
          <h5 class="mb-0 f-14">
            <div class="px-0 w-100">
              <div class="f-14 w-100">
                <div class="d-flex w-100 align-items-baseline">
                  <!-- Handle collapse logic -->
                  <button data-testid="auto-person-search-filter-button-28" (click)="toggleFilter('keyword')" id="collapseThirtyNineBtn"
                    class="static collapsed font-weight-500 text-left flex-grow-1 btn f-14 ml--7" type="button" data-bs-target="#collapseThirtyNine" data-bs-toggle="collapse"
                    aria-bs-expanded="false" aria-bs-controls="collapseThirtyNine"> Keyword
                  </button>
                  <span class="toggle mr-5" style="flex-shrink: 0;">
                    <div class="down">
                      <span *ngIf="keywordSelectedList.length" class="red-dot">&bull;</span>
                    </div>
                  </span>
                  <span class="toggle ml-auto mr-5" style="flex-shrink: 0;">
                    <div class="up">
                      <div class="d-flex align-items-center mb-2">
                        <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex"
                          (click)="clearFilters('keyword')" *ngIf="keywordSelectedList.length">
                          Reset
                        </span>
                      </div>
                    </div>
                  </span>
                  <label for="collapseThirtyNineBtn" class="toggle text-webbtree-green">
                    <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                    <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                  </label>
                </div>
              </div>
            </div>
          </h5>
        </div>

        <div id="collapseThirtyNine" class="collapse mb-2" aria-bs-labelledby="headingThirtyNine">
          <mat-chip-grid #keyword_chipList>
            <mat-chip-row class="mr-2 mb-1 rightsideclose text-truncate d-flex"
               [removable]="removable" (removed)="removeChip(kw, 'keyword')"
              style="background-color: #e4f1f3;" *ngFor="let kw of keywordSelectedList">
              <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 font-weight-lighter"></i>
              </span>
              <span class="trim-chip text-truncate f-12 font-weight-lighter">{{kw.chipkey | titlecase}}
              </span>
            </mat-chip-row>
          </mat-chip-grid>
          <div class="position-relative">
            <input data-testid="auto-person-search-filter-input-24" class="wc-form-control no-shadow w-100 inputheight mb-2" placeholder="eg. Engineering, Testing, etc"
              [formControl]="keyword_input" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (click)="typeAheadSearch($event, 'keyword')" (keyup)="onTypeAheadSearch($event, 'keyword')"
              [matAutocomplete]="keyword_auto"
              (keyup.enter)="addToSelectedList($event.target.value,'keyword', 'enter');$event.target.blur();trigger.closePanel()"
              [matChipInputFor]="keyword_chipList" [matChipInputAddOnBlur]="addOnBlur">
            <div *ngIf="showKeywordLoader" class=" spinner-border position-absolute text-black"
              style="top:13px; right: 7px;" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <mat-autocomplete #keyword_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'keyword')">
              <mat-option *ngFor="let keyword of keywordlist" [value]="{key: keyword.value}">
                <span class="d-flex align-items-center">
                  <span class="text-truncate">{{keyword.value | titlecase}}</span>
                </span>
              </mat-option>
            </mat-autocomplete>
          </div>

        </div>
      </div>

      <!-- Highlights -->
      <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.HIGHLIGHTS)" style="border-bottom: none;">
        <div class="card-header" id="headingHighlights">
          <h5 class="mb-0 f-14">
            <div class="px-0 w-100">
              <div class="f-14 w-100">
                <div class="d-flex w-100 align-items-baseline">
                  <button data-testid="auto-person-search-filter-button-29" (click)="toggleFilter('highlights')" id="collapseHighlightsBtn"
                    [ngClass]="{'collapsed': highlightsSelectedList?.length == 0}"
                    class="static font-weight-500 text-left flex-grow-1 btn f-14 ml--7" type="button"
                    aria-bs-expanded="false" data-bs-target="#collapseHighlights" data-bs-toggle="collapse"
                    aria-bs-controls="collapseHighlights"> Highlights
                  </button>
                  <span class="toggle mr-5" style="flex-shrink: 0;">
                    <div class="down">
                      <span *ngIf="highlightsSelectedList?.length" class="red-dot" style="left: 100px;">&bull;</span>
                    </div>
                  </span>
                  <span class="toggle ml-auto mr-5" style="flex-shrink: 0;">
                    <div class="up">
                      <div class="d-flex align-items-center mb-2">
                        <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex"
                          (click)="clearFilters('highlight')" *ngIf="highlightsSelectedList?.length">
                          Reset
                        </span>
                      </div>
                    </div>
                  </span>
                  <label for="collapseHighlightsBtn" class="toggle text-webbtree-green">
                    <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                    <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                  </label>
                </div>
              </div>
            </div>
          </h5>
        </div>
        <div id="collapseHighlights" class="highlight-filter collapse mb-2 mx-1 pb-2"
          [class.show]="isExpanded('highlights', highlightsSelectedList?.length > 0)" aria-bs-labelledby="headingHighlights">
          <div class="mb-2">
            <mat-chip-set #highlight_chipList *ngIf="highlightsSelectedList.length">
              <mat-chip class="mr-2 my-1 rightsideclose text-truncate" [removable]="removable"
                ngClass="highlight-pill-{{hl.color}}" *ngFor=" let hl of highlightsSelectedList">
                <span matChipRemove  class="mr-1">
                  <i class="far fa-times f-12 font-weight-lighter" style="margin-left: 1px;"
                  (click)="removeChip(hl, 'highlight')"></i>
                </span>
                <span class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center">
                  <span class="mx-1">
                    <span *ngIf="hl?.imageName" class="mr-1">
                      <img [src]="'assets/highlights/' + hl.imageName + '.svg'" alt="">
                    </span>
                    {{hl.label}}
                  </span>
                </span>
              </mat-chip>
            </mat-chip-set>

            <!-- <mat-chip-grid #highlight_chipList>
                    <mat-chip class="mr-2 my-1 rightsideclose text-truncate green-chip" [removable]="removable"
                        *ngIf="highlightsSelectedList.includes('All')">
                        <i class="far fa-times f-12" matChipRemove style="margin-left: 1px;"
                            (click)="removeChip('All', 'highlight')"></i>
                        <span class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center">
                            <span class="mx-1">All</span>
                        </span>
                    </mat-chip>
                </mat-chip-grid> -->
          </div>
          <div class="company-seniority highlight-select">
            <p-multiSelect [options]="highLightOptions" optionLabel="label" optionValue="id"
              [(ngModel)]="highlightSelectedControl" (onChange)="onChangeHighlights($event)"
              placeholder="Select Highlight" [filter]="false">
              <ng-template let-value pTemplate="selectedItems">
                <div>Select Highlight</div>
              </ng-template>
              <ng-template pTemplate="header">
                <div class="flex align-items-center gap-2">
                  <div class="p-multiselect-header-checkbox">
                    <span class="p-checkbox-label">All</span>
                  </div>
                </div>
              </ng-template>
              <ng-template let-cs pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <div class="highlight-pill" ngClass="highlight-pill-{{cs.color}}">
                    <span *ngIf="cs?.imageName" class="mr-1">
                      <img [src]="'assets/highlights/' + cs.imageName + '.svg'" alt="">
                    </span>
                    {{ cs.label }}
                  </div>
                </div>
              </ng-template>
            </p-multiSelect>
          </div>
        </div>
      </div>

      <!-- Position Hierarchy -->
      <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.POSITION_HIERARCHY)">
        <div class="card-header" id="headingThirty">
          <h5 class="mb-0 f-14">
            <div class="px-0 w-100">
              <div class="f-14 w-100">
                <div class="d-flex w-100 align-items-baseline">
                  <button data-testid="auto-person-search-filter-button-30" (click)="toggleFilter('positionhierarchy')" id="collapseThirtyBtn"
                    [ngClass]="{'collapsed': positionhierarchy?.length == 0}"
                    class="static collapsed font-weight-500 text-left flex-grow-1 btn f-14 ml--7" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThirty"
                    aria-bs-expanded="false"
                    aria-bs-controls="collapseThirty"> Webbtree True Level
                    <i class="fa-regular fa-circle-info f-12 custom-tooltip"
                      matTooltip="This filter rationalizes roles by considering both job seniority and company size to enable fair comparisons—for example, a VP at a startup is categorized differently from a VP at a global enterprise."
                      [matTooltipClass]="{ 'hire-filter text-black': true }"></i>
                  </button>
                  <span class="toggle mr-5" style="flex-shrink: 0;">
                    <div class="down">
                      <span *ngIf="positionhierarchy?.length > 0" class="red-dot">&bull;</span>
                    </div>
                  </span>
                  <span class="toggle ml-auto mr-5" style="flex-shrink: 0;">
                    <div class="up">
                      <div class="d-flex align-items-center mb-2">
                        <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex"
                          (click)="clearFilters('positionhierarchy')">
                          Reset
                        </span>
                      </div>
                    </div>
                  </span>
                  <label for="collapseThirtyBtn" class="toggle text-webbtree-green">
                    <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                    <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                  </label>
                </div>
              </div>
            </div>
          </h5>
        </div>

        <div id="collapseThirty" class="collapse mb-2 company-seniority"
          [class.show]="isExpanded('positionhierarchy', positionhierarchy?.length > 0)" aria-bs-labelledby="headingThirty">
          <div [ngClass]="{'mb-3':positionhierarchy.length>0}">
            <mat-chip-set class="mb-2" #positionhierarchy__chipList *ngIf="!positionhierarchy.includes('All')">
              <mat-chip class="mr-2 mb-1 rightsideclose text-truncate d-flex" [removable]="removable"
                style="background-color: #e4f1f3;" *ngFor="let ph of positionhierarchy">
                <span matChipRemove  class="mr-1">
                  <i class="far fa-times f-12 font-weight-lighter" style="margin-left: 1px;
                    margin-top: 5px;" (click)="removeChip(ph, 'positionhierarchy')"></i>
                </span>
                <span class="trim-chip text-truncate f-12 font-weight-lighter">
                  <span class="mx-1" [matTooltip]="ph | titlecase" [matTooltipClass]="{ 'hire-filter text-black': true }"
                    matTooltipPosition="above">{{ph | titlecase}}</span>
                </span>
              </mat-chip>
            </mat-chip-set>

            <mat-chip-set class="mb-2" #positionhierarchy__chipList>
              <mat-chip class="mr-2 mb-1 rightsideclose text-truncate d-flex" [removable]="removable"
                style="background-color: #e4f1f3;" *ngIf="positionhierarchy.includes('All')">
                <span matChipRemove  class="mr-1">
                  <i class="far fa-times f-12 font-weight-lighter" style="margin-left: 1px;
                    margin-top: 5px;" (click)="removeChip('All', 'positionhierarchy')"></i>
                </span>
                <span class="trim-chip text-truncate f-12 font-weight-lighter">
                  <span class="mx-1">All</span>
                </span>
              </mat-chip>
            </mat-chip-set>
          </div>
          <p-multiSelect [options]="positionHierarchyData" [(ngModel)]="positionhierarchy"
            (onChange)="selectedItem($event, 'positionhierarchy')" placeholder="Select Position Hierarchy"
            optionLabel="name" [filter]="false" class="mt-3">
            <ng-template let-value pTemplate="selectedItems">
              <div>Select Webbtree True Level</div>
            </ng-template>
            <ng-template pTemplate="header">
              <div class="flex align-items-center gap-2">
                <div class="p-multiselect-header-checkbox">
                  <span class="p-checkbox-label">All</span>
                </div>
              </div>
            </ng-template>
            <ng-template let-ph pTemplate="item">
              <div class="flex align-items-center gap-2">
                <div>{{ ph | titlecase }}</div>
              </div>
            </ng-template>
          </p-multiSelect>
        </div>
      </div>

      <!-- Years of graduation -->
      <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.GRADUATION_YEAR)">
        <div class="card-header" id="headingGraduationYear">
          <h5 class="mb-0 f-14">
            <div class="px-0 w-100">
              <div class="f-14 w-100">
                <div class="d-flex w-100 align-items-baseline">
                  <button data-testid="auto-person-search-filter-button-31" (click)="toggleFilter('graduationYear')" id="collapseGraduationBtn"
                    [ngClass]="{'collapsed': !isGraduationFilterApplied}"
                    class="static font-weight-500 text-left flex-grow-1 btn f-14 ml--7" type="button"
                    aria-bs-expanded="false" data-bs-target="#collapseGraduation" data-bs-toggle="collapse"
                    aria-bs-controls="collapseGraduation"> Year of graduation </button>
                  <span class="toggle mr-5" style="flex-shrink: 0;">
                    <div class="down">
                      <span *ngIf="isGraduationFilterApplied" class="red-dot" style="left: 165px;">&bull;</span>
                    </div>
                  </span>
                  <label for="collapseGraduationBtn" class="toggle text-webbtree-green">
                    <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                    <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                  </label>
                </div>
              </div>
            </div>
          </h5>
        </div>

        <div id="collapseGraduation" class="collapse mb-2" [class.show]="isExpanded('graduationYear', isGraduationFilterApplied)"
          aria-bs-labelledby="headingGraduationYear">

          <div class="d-flex align-items-center ml-2 w-100">
            <label class="f-14 text-black mr-2 mt-2">From</label>
            <select data-testid="auto-person-search-filter-select-8" name="fromgraduationyear" placeholder="YYYY" [(ngModel)]="fromgraduationyearFilter"
              (change)="onOptionChangeGraduationFilter($event.target.value, 'fromgraduationyearFilter')"
              style="width: fit-content;" class="wc-form-control position-relative no-outline inputheight wc-select">
              <option value="null" selected disabled>year</option>
              <span *ngFor="let year of graduationYearList('from')">
                <option [value]=year>{{year}}</option>
              </span>
            </select>

            <label class="f-14 text-black m-2">To</label>
            <select data-testid="auto-person-search-filter-select-9" name="torgaduationyear" placeholder="YYYY" [(ngModel)]="tograduationyearFilter"
              (change)="onOptionChangeGraduationFilter($event.target.value, 'tograduationyearFilter')"
              style="width: fit-content;" class="wc-form-control position-relative no-outline inputheight wc-select">
              <option value="null" selected disabled>year</option>
              <span *ngFor="let year of graduationYearList('to')">
                <option [value]=year>{{year}}</option>
              </span>
            </select>
          </div>

          <div class="col position-relative wccard" *ngIf="dataSourceGraduationYears">
            <div>
              <div class="loader" *ngIf="!dataSourceGraduationYears">
                <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
              </div>
              <fusioncharts width="100%" height="250" type="spline" [dataSource]="dataSourceGraduationYears"
                *ngIf="dataSourceGraduationYears && dataSourceGraduationYears?.data?.length">
              </fusioncharts>
            </div>
            <div class="d-flex justify-content-end align-items-center">
              <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex mr-4"
                (click)="clearFilters('graduationYears')">
                Reset
              </span>
              <button data-testid="auto-person-search-filter-button-32" class="btn-trms-xs-small m-0" (click)="applyFilter('graduationYears')"
                [disabled]="!validGraduationYears()"
                [ngClass]="!validGraduationYears() ? 'disabled-btn-experience' : 'btn-trms-xs-small'">Apply</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Changed Jobs -->
      <!-- <div class="card bt px-2" *ngIf="shouldShowFilter(filterNames.CHANGED_JOB)">
        <div class="card-header" id="headingSixteen">
            <h5 class="mb-0 f-14">
                <div class="px-0 w-100">
                    <div class="f-14 w-100" >
                        <div class="d-flex w-100 align-items-baseline">
                            <button data-testid="auto-person-search-filter-button-33" (click)="toggleFilter('changedJobs')" id="collapseSixteenBtn" class="static collapsed font-weight-500 text-left flex-grow-1 btn f-14 ml--7" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSixteen" aria-expanded="false" aria-controls="collapseSixteen"> Changed Jobs</button>
                            <span class="toggle mr-5" style="flex-shrink: 0;">
                                <div class="down">
                                     <span *ngIf="changedJobDuration > 0"  class="red-dot" style="left: 145px;">&bull;</span>
                                </div>
                            </span>
                            <span class="toggle ml-auto mr-5" style="flex-shrink: 0;">
                                <div class="up">
                                    <div class="d-flex align-items-center mb-2">
                                        <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex" (click)="clearFilters('changedjobs')">
                                           Reset
                                        </span>
                                    </div>
                                </div>
                            </span>
                            <label for="collapseSixteenBtn" class="toggle text-webbtree-green">
                                <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                                <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                            </label>
                        </div>
                    </div>
                </div>
            </h5>
        </div>

        <div id="collapseSixteen" class="collapse mb-2" aria-labelledby="headingSixteen">
            <select data-testid="auto-person-search-filter-select-10" name="changedJobDuration" (change)="selectedItem($event, 'changedJobs')" placeholder="Select from following"
                [(ngModel)]="changedJobDuration" class="wc-form-control position-relative no-outline inputheight wc-select">
                <option value=null disabled selected>Select following options</option>
                <option value=3>Exclude Past 3 months</option>
                <option value=6>Exclude Past 6 months</option>
                <option value=9>Exclude Past 9 months</option>
                <option value=12>Exclude Past 1 Year</option>
            </select>
        </div>
      </div> -->

    </div>
  </div>
</span>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert error-message-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
